/* eslint-disable */
// THIS FILE WAS GENERATED
// ALL CHANGES WILL BE OVERWRITTEN

// INFRASTRUCTURE START
  export type StandardError = globalThis.Error;
  export type Error500s = 501 | 502 | 503 | 504 | 505 | 506 | 507 | 508 | 510 | 511;
  export type ErrorStatuses = 0 | Error500s;
  export type ErrorResponse = FetchResponse<unknown, ErrorStatuses>;

  export type FetchResponseOfError = {
    data: null;
    error: StandardError;
    status: ErrorStatuses;
    args: any;
  };

  export type FetchResponseOfSuccess<TData, TStatus extends number = 0> = 
  {
    data: TData;
    error: null;
    status: TStatus;
    args: any;
    responseHeaders: Headers;
  };

  export type FetchResponse<TData, TStatus extends number = 0> = 
    TStatus extends ErrorStatuses ? FetchResponseOfError: FetchResponseOfSuccess<TData, TStatus>;

  export type TerminateRequest = null;
  export type TerminateResponse = null;

  export type Configuration = {
    apiUrl: string | (() => string);
    jwtKey: string | undefined | (() => string | null | undefined);
    requestMiddlewares?: Array<{
      name: string;
      fn: (request: FetchArgs) => FetchArgs | TerminateRequest;
    }>;
    responseMiddlewares?: Array<{
      name: string;
      fn: (
        response: FetchResponse<unknown, any>
      ) => FetchResponse<unknown, any> | TerminateResponse;
    }>;
  };

  let CONFIG: Configuration = {
    apiUrl: () => "",
    jwtKey: undefined,
    requestMiddlewares: [],
    responseMiddlewares: [],
  };

  export function setupClient(configuration: Configuration) {
    CONFIG = {
      ...CONFIG,
      ...configuration,
      requestMiddlewares: [
        ...(CONFIG.requestMiddlewares || []),
        ...(configuration.requestMiddlewares || []),
      ],
      responseMiddlewares: [
        ...(CONFIG.responseMiddlewares || []),
        ...(configuration.responseMiddlewares || []),
      ],
    };
  }

  export function getApiUrl() {
    if (typeof CONFIG.apiUrl === "function") {
      return CONFIG.apiUrl();
    }
    return CONFIG.apiUrl;
  }

  export type Termination = {
    termination: {
      name: string;
    };
  };

  export function processRequestWithMiddlewares(
    request: FetchArgs
  ): FetchArgs | Termination {
    for (const middleware of CONFIG.requestMiddlewares || []) {
      try {
        const middlewareResponse = middleware.fn(request);
        if (middlewareResponse === null) {
          return { termination: { name: middleware.name } };
        }
        request = middlewareResponse;
      } catch (e) {
        console.error("Request middleware error", e);
      }
    }
    return request;
  }

  export function processResponseWithMiddlewares<T extends FetchResponse<unknown, any>>(
    response: T
  ): T | Termination {
    for (const middleware of CONFIG.responseMiddlewares || []) {
      try {
        const middlewareResponse = middleware.fn(response);
        if (middlewareResponse === null) {
          return {
            status: 0,
            args: response.args,
            data: null,
            error: new Error(
              `Response terminated by middleware: ${middleware.name}`
            ),
          } as FetchResponseOfError as unknown as T;
        }
        response = middlewareResponse as T;
      } catch (e) {
        console.error("Response middleware error", e);
      }
    }
    return response;
  }

  export type FetchOptions = {
    method: string;
    headers: Headers;
    body?: any;
    redirect: RequestRedirect;
  };

  export type FetchArgs = {
    url: string;
    options: FetchOptions;
  }

  export async function fetchJson<T extends FetchResponse<unknown, number>>(
    args: FetchArgs
  ): Promise<T> {
    const errorResponse = (error: StandardError, status: number, args: any) => {
      const errorResponse = {
        status: status as ErrorStatuses,
        args,
        data: null,
        error,
      } satisfies FetchResponse<T>;

      return processResponseWithMiddlewares(errorResponse) as unknown as T;
    };

    const errorStatus = (args: any) => {
      const errorResponse = {
        status: 0,
        args,
        data: null,
        error: new Error("Network error"),
      } as FetchResponse<T, Error500s>;

      return processResponseWithMiddlewares(errorResponse) as unknown as T;
    };

    try {
      const fetchRequest = processRequestWithMiddlewares(args);

      if ("termination" in fetchRequest) {
        const terminationResponse = {
          status: 0,
          args,
          data: null,
          error: new Error(
            `Request terminated by middleware: ${fetchRequest.termination.name}`
          ),
        } as FetchResponse<T, Error500s>;

        return processResponseWithMiddlewares(
          terminationResponse
        ) as unknown as T;
      }

      const fetchResponse: Response = await fetch(fetchRequest.url, fetchRequest.options);
      const status = fetchResponse.status;
      try {
        const json = await fetchResponse.json();
        const response = {
          data: json,
          status: fetchResponse.status,
          args,
          error: null,
          responseHeaders: fetchResponse.headers,
        };
        return processResponseWithMiddlewares(response) as unknown as T;
      } catch (error) {
        return errorResponse(error as StandardError, status, args);
      }
    } catch {
      return errorStatus(args);
    }
  }

  export function getJwtKey(): string | null | undefined {
    if (typeof CONFIG.jwtKey === "function") {
      return CONFIG.jwtKey();
    }

    if (typeof CONFIG.jwtKey === "string") {
      return localStorage.getItem(CONFIG.jwtKey);
    }

    return undefined;
  } 
  
  
 function getApiRequestData<Type extends any>(
    requestContract: Type | undefined,
    isFormData: boolean = false
  ): FormData | Type | {} {
  
    if (!isFormData) {
      return requestContract !== undefined ? requestContract : {};
    }
  
    //multipart/form-data
    const formData = new FormData();
  
     if (requestContract) {
      Object.keys(requestContract).forEach(key => {
        const value = requestContract[key as keyof Type];
        const isKeyArrayAndValueIterable = key.endsWith('[]') && typeof (value as any)[Symbol.iterator] === 'function';
        const values = isKeyArrayAndValueIterable ? Array.from(value as Iterable<any>) : [value];
          for (const val of values) {
              if (val === undefined) {
                  continue;
              } else if (val === null) {
                  formData.append(key, '');
              } else if (val instanceof File) {
                  formData.append(key, val);
              } else if (typeof val === 'object' && val !== null) {
                  formData.append(key, JSON.stringify(val));
              } else {
                  formData.append(key, val as any);
              }
          }
      });
    }
  
    return formData;
  }

  
  function updateHeadersAndGetBody<TResponse extends FetchResponse<unknown, number>, TRequest>(
    request: TRequest,
    headers: Headers
  ) {
    updateHeaders(headers);
    if (request instanceof FormData) {
      headers.delete("Content-Type");
      return request;
    } else {      
      return JSON.stringify(request);
    }
  }
  
  function updateHeaders(headers: Headers) {
    if (!headers.has("Content-Type")) {
      headers.append("Content-Type", "application/json");
    }
    const token = getJwtKey();
    if (!headers.has("Authorization") && !!token) {
      headers.append("Authorization", token);
    }
  }

export function getQueryParamsString(paramsObject: ParamsObject = {}) {
	const queryString = Object.entries(paramsObject)
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return value
          .map(val => `${encodeURIComponent(key)}=${encodeURIComponent(
            val,
          )}`)
          .join('&');
      }
      // Handling non-array parameters
      return value !== undefined && value !== null 
        ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` 
        : '';
    })
    .filter(part => part !== '')
    .join("&");

	return queryString.length > 0 ? `?${queryString}` : '';
}

export function apiPost<TResponse extends FetchResponse<unknown, number>, TRequest>(
  url: string,
  request: TRequest,
  headers: Headers,
  paramsObject: ParamsObject = {}
) {
  
  const raw = updateHeadersAndGetBody(request, headers); 

  const requestOptions: FetchOptions = {
    method: "POST",
    headers,
    body: raw,
    redirect: "follow",
  };

  const maybeQueryString = getQueryParamsString(paramsObject);

  return fetchJson<TResponse>({
    url: `${url}${maybeQueryString}`,
    options: requestOptions,
  });
}

export type ParamsObject = {
  [key: string]: any;
};

export function apiGet<TResponse extends FetchResponse<unknown, number>>(
  url: string,
  headers: Headers,
  paramsObject: ParamsObject = {}
) {
  updateHeaders(headers);
  
  const maybeQueryString = getQueryParamsString(paramsObject);

  const requestOptions: FetchOptions = {
    method: "GET",
    headers,
    redirect: "follow",
  };

  return fetchJson<TResponse>({
    url: `${url}${maybeQueryString}`,
    options: requestOptions,
  });
}

export function apiPut<TResponse extends FetchResponse<unknown, number>, TRequest>(
  url: string,
  request: TRequest,
  headers: Headers,
  paramsObject: ParamsObject = {}
) {
  updateHeaders(headers);

  const raw = JSON.stringify(request);

  const requestOptions: FetchOptions = {
    method: "PUT",
    headers,
    body: raw,
    redirect: "follow",
  };

  const maybeQueryString = getQueryParamsString(paramsObject);

  return fetchJson<TResponse>({
    url: `${url}${maybeQueryString}`,
    options: requestOptions,
  });
}

export function apiDelete<TResponse extends FetchResponse<unknown, number>>(
  url: string,
  headers: Headers,
  paramsObject: ParamsObject = {}
) {
  updateHeaders(headers);

  const queryString = Object.entries(paramsObject)
    .filter(([_, val]) => val !== undefined && val !== null)
    .map(([key, val]) => `${key}=${val}`)
    .join("&");
  
  const maybeQueryString = queryString.length > 0 ? `?${queryString}` : "";

  const requestOptions: FetchOptions = {
    method: "DELETE",
    headers,
    redirect: "follow",
  };

  return fetchJson<TResponse>({
    url: `${url}${maybeQueryString}`,
    options: requestOptions,
  });
}

export function apiPatch<TResponse extends FetchResponse<unknown, number>, TRequest>(
  url: string,
  request: TRequest,
  headers: Headers,
  paramsObject: ParamsObject = {}
) {
  updateHeaders(headers);

  const raw = JSON.stringify(request);

  const requestOptions: FetchOptions = {
    method: "PATCH",
    headers,
    body: raw,
    redirect: "follow",
  };
  const maybeQueryString = getQueryParamsString(paramsObject);

  return fetchJson<TResponse>({
    url: `${url}${maybeQueryString}`,
    options: requestOptions,
  });
}
// INFRASTRUCTURE END

export enum OrderStatus {
	pending = "pending",
	confirmed = "confirmed",
	in_progress = "in_progress",
	cancelled = "cancelled",
	done = "done"
};

export enum OrderFieldTypeEnum {
	integer = "integer",
	float = "float",
	string = "string",
	boolean = "boolean",
	enum = "enum"
};

export type OrderFieldResponseDto = {
	id: number;
	key: string;
	label: string;
	type: OrderFieldTypeEnum;
	value: string;
	orderIndex: number;
	emailLabel?: string | null;
	isEmailIncluded?: boolean | null;
};

export type OrderFieldValueResponseDto = {
	orderField: OrderFieldResponseDto;
	value: string;
};

export type OrderAgentResponseDto = {
	id: number;
	status: OrderStatus;
	address?: string | null;
	fields: OrderFieldValueResponseDto[];
	price?: number | null;
	materialPrice?: number | null;
};

export enum FollowUpAgentStatusEnum {
	agent_started = "agent_started",
	agent_completed = "agent_completed",
	agent_abandoned = "agent_abandoned",
	quote_scope_confirmed = "quote_scope_confirmed",
	quote_requested_changes = "quote_requested_changes",
	booking_deferred = "booking_deferred",
	booking_abandoned = "booking_abandoned",
	booking_confirmed = "booking_confirmed",
	booking_cancelled = "booking_cancelled",
	quote_deferred = "quote_deferred",
	in_progress = "in_progress",
	completed = "completed",
	not_completed_panic = "not_completed_panic",
	not_completed_timeout = "not_completed_timeout"
};

export enum OrderPackage {
	standard = "standard",
	economy = "economy",
	premium = "premium"
};

export type OrderPublicResponseDto = {
	orderId: number;
	orderStatus: string;
	followUpAgentStatus?: FollowUpAgentStatusEnum | null;
	vertical: string;
	service: string;
	price?: number | null;
	calculatedPrice: number;
	country?: string | null;
	currency?: string | null;
	city?: string | null;
	address?: string | null;
	additionalInfo?: string | null;
	fields: OrderFieldValueResponseDto[];
	name?: string | null;
	email?: string | null;
	phone?: string | null;
	depositPercentage?: number | null;
	depositLimitAmount?: number | null;
	staticDepositAmount?: number | null;
	packageType?: OrderPackage | null;
};

export enum OrderDirection {
	asc = "asc",
	desc = "desc"
};

export enum OrderPartnerReviewRatingEnum {
	satisfied = "satisfied",
	not_satisfied = "not_satisfied"
};

export type OrderFilterDto = {
	status?: OrderStatus[] | null;
	dateNextActionFrom?: string | null;
	dateNextActionTo?: string | null;
	dateStartingFrom?: string | null;
	dateStartingTo?: string | null;
	isNew?: boolean | null;
	isHasClaim?: boolean | null;
	marketId?: number | null;
	partnerId?: number | null;
	unassignedPartner?: boolean | null;
	regionId?: number | null;
	userId?: number | null;
	unassignedUser?: boolean | null;
	query?: string | null;
	pageLimit?: number | null;
	pageIndex?: number | null;
	isDeleted?: boolean | null;
	orderBy?: string | null;
	orderDirection?: OrderDirection | null;
	review?: OrderPartnerReviewRatingEnum | null;
	notReviewed?: boolean | null;
	hasExamination?: boolean | null;
	claimDateNextActionFrom?: string | null;
	claimDateNextActionTo?: string | null;
	verticals?: string | null;
	b2b?: string | null;
	promoCode?: string | null;
	followUpAgentStatus?: FollowUpAgentStatusEnum[] | null;
};

export enum CountryEnum {
	AUT = "AUT",
	BEL = "BEL",
	BGR = "BGR",
	HRV = "HRV",
	CYP = "CYP",
	CZE = "CZE",
	DNK = "DNK",
	EST = "EST",
	FIN = "FIN",
	FRA = "FRA",
	DEU = "DEU",
	GRC = "GRC",
	HUN = "HUN",
	IRL = "IRL",
	ITA = "ITA",
	LVA = "LVA",
	LTU = "LTU",
	LUX = "LUX",
	MLT = "MLT",
	NLD = "NLD",
	POL = "POL",
	PRT = "PRT",
	ROU = "ROU",
	SVK = "SVK",
	SVN = "SVN",
	ESP = "ESP",
	SWE = "SWE",
	NOR = "NOR",
	CHE = "CHE",
	GBR = "GBR",
	ISL = "ISL",
	SRB = "SRB",
	UKR = "UKR",
	USA = "USA",
	CAN = "CAN",
	MEX = "MEX",
	CRI = "CRI",
	CUB = "CUB",
	DOM = "DOM",
	JAM = "JAM",
	PAN = "PAN",
	BRA = "BRA",
	ARG = "ARG",
	COL = "COL",
	CHL = "CHL",
	PER = "PER",
	VEN = "VEN",
	URY = "URY",
	ECU = "ECU",
	PRY = "PRY",
	BOL = "BOL",
	CHN = "CHN",
	IND = "IND",
	JPN = "JPN",
	IDN = "IDN",
	KOR = "KOR",
	PAK = "PAK",
	BGD = "BGD",
	PHL = "PHL",
	VNM = "VNM",
	THA = "THA",
	MYS = "MYS",
	SGP = "SGP",
	AUS = "AUS",
	NZL = "NZL",
	FJI = "FJI",
	PNG = "PNG",
	RUS = "RUS",
	NGA = "NGA",
	ETH = "ETH",
	EGY = "EGY",
	ZAF = "ZAF",
	DZA = "DZA",
	MAR = "MAR",
	KEN = "KEN",
	GHA = "GHA",
	TZA = "TZA",
	UGA = "UGA",
	SDN = "SDN",
	SAU = "SAU",
	TUR = "TUR",
	IRN = "IRN",
	ISR = "ISR",
	ARE = "ARE",
	IRQ = "IRQ",
	QAT = "QAT"
};

export enum CurrencyEnum {
	AED = "AED",
	ARS = "ARS",
	AUD = "AUD",
	BDT = "BDT",
	BGN = "BGN",
	BOB = "BOB",
	BRL = "BRL",
	CAD = "CAD",
	CHF = "CHF",
	CLP = "CLP",
	CNY = "CNY",
	COP = "COP",
	CRC = "CRC",
	CUP = "CUP",
	CZK = "CZK",
	DKK = "DKK",
	DOP = "DOP",
	DZD = "DZD",
	EGP = "EGP",
	EUR = "EUR",
	FJD = "FJD",
	GBP = "GBP",
	GHS = "GHS",
	HRK = "HRK",
	HUF = "HUF",
	IDR = "IDR",
	ILS = "ILS",
	INR = "INR",
	IQD = "IQD",
	IRR = "IRR",
	ISK = "ISK",
	JMD = "JMD",
	JPY = "JPY",
	KES = "KES",
	KRW = "KRW",
	MAD = "MAD",
	MXN = "MXN",
	MYR = "MYR",
	NGN = "NGN",
	NOK = "NOK",
	NZD = "NZD",
	PAB = "PAB",
	PEN = "PEN",
	PHP = "PHP",
	PKR = "PKR",
	PLN = "PLN",
	PYG = "PYG",
	QAR = "QAR",
	RON = "RON",
	RSD = "RSD",
	RUB = "RUB",
	SAR = "SAR",
	SDG = "SDG",
	SEK = "SEK",
	SGD = "SGD",
	THB = "THB",
	TRY = "TRY",
	TZS = "TZS",
	UGX = "UGX",
	USD = "USD",
	UAH = "UAH",
	UYU = "UYU",
	VES = "VES",
	VND = "VND",
	ZAR = "ZAR"
};

export type MarketRegionResponseDto = {
	id: number;
	name: string;
	regionCode?: string | null;
	marketId: number;
	isDeleted: boolean;
	timezone?: string | null;
};

export type MarketResponseDto = {
	id: number;
	name: string;
	webReferrer: string;
	country: CountryEnum;
	currency: CurrencyEnum;
	iconPath?: string | null;
	imagePath?: string | null;
	dateCreated: string;
	regions: MarketRegionResponseDto[];
	urlPath: string;
	companyId: number;
	companyBankDetailId: number;
	timezone: string;
	b2bOptions?: string | null;
	isActive: boolean;
};

export enum OrderCallType {
	inbound = "inbound",
	outbound = "outbound"
};

export enum OrderCallStatus {
	no_answer = "no_answer",
	answered = "answered"
};

export type OrderCallResponseDto = {
	id: number;
	orderId: number;
	operatorId: string;
	type: OrderCallType;
	status: OrderCallStatus;
	dateCreated: string;
};

export type OrderVerticalResponseDto = {
	id: number;
	name: string;
	iconPath: string;
};

export type OrderListRowResponseDto = {
	id: number;
	dateCreated: string;
	dateNextAction: string;
	dateStarting?: string | null;
	status: OrderStatus;
	customerName: string;
	partnerName: string;
	partnerId?: number | null;
	market?: MarketResponseDto | null;
	region?: MarketRegionResponseDto | null;
	userId?: number | null;
	userName?: string | null;
	userSurname?: string | null;
	customerPhone?: string | null;
	customerEmail?: string | null;
	customerRegion?: string | null;
	orderCalls: OrderCallResponseDto[];
	hasExamination: boolean;
	examinationDate?: string | null;
	hasClaim: boolean;
	price: number;
	materialPrice: number;
	vertical: OrderVerticalResponseDto;
	b2b?: string | null;
	followUpAgentStatus: FollowUpAgentStatusEnum;
	promoCode?: string | null;
};

export type PayloadMetaDataResponseDto = {
	count: number;
};

export type OrderListAllResponseDto = {
	data?: OrderListRowResponseDto[] | null;
	metaData?: PayloadMetaDataResponseDto | null;
};

export type OrderMetaResponseDto = {
	count: number;
};

export type OrderPartnerNameResponseDto = {
	orderId: number;
	partnerName?: string | null;
};

export type CustomerResponseDto = {
	id: number;
	name: string;
	email: string;
	phone: string;
	dateCreated: string;
	invoicingName?: string | null;
	invoicingAddress?: string | null;
	businessId?: string | null;
};

export enum PartnerStatus {
	ACTIVE = "ACTIVE",
	DELETED = "DELETED",
	BLOCKED = "BLOCKED"
};

export enum PartnerSkills {
	WALLPAPERING = "WALLPAPERING",
	EXTERIOR_PAINTING = "EXTERIOR_PAINTING",
	INTERIOR_PAINTING = "INTERIOR_PAINTING",
	INTERIOR_PAINTING_PREMIUM = "INTERIOR_PAINTING_PREMIUM",
	PLUMBING = "PLUMBING",
	TILING = "TILING",
	PLASTERBOARDS = "PLASTERBOARDS",
	PLASTERING = "PLASTERING",
	REWIRING = "REWIRING",
	REVISION = "REVISION",
	PARQUET = "PARQUET",
	PARQUET_RENO = "PARQUET_RENO",
	CARPET = "CARPET",
	LINO = "LINO",
	VINYL = "VINYL",
	HANDYMAN = "HANDYMAN"
};

export type PartnerGeneralResponseDto = {
	id: number;
	invoiceIdentifier: string;
	name: string;
	middleName?: string | null;
	surname: string;
	email: string;
	phone: string;
	teamSize: number;
	isCanTrainDay: boolean;
	status: PartnerStatus;
	marketId: number;
	marketRegionId: number;
	profileLink?: string | null;
	fullName: string;
	verticals: OrderVerticalResponseDto[];
	skills?: PartnerSkills[] | null;
	notes?: string | null;
};

export enum OrderCancellationReasonEnum {
	irrelevant_request = "irrelevant_request",
	did_not_reach = "did_not_reach",
	no_answer = "no_answer",
	competition = "competition",
	price = "price",
	professional = "professional",
	other = "other",
	online_booking = "online_booking"
};

export enum OrderTypeNotification {
	customer = "customer",
	partner = "partner",
	deposit = "deposit",
	review = "review"
};

export type OrderEmailNotificationResponseDto = {
	id: number;
	orderId: number;
	type: OrderTypeNotification;
	dateSent: string;
};

export enum ClaimStatusEnum {
	active = "active",
	resolved = "resolved"
};

export enum ClaimTypeEnum {
	quality = "quality",
	cleaning = "cleaning",
	time_management = "time_management",
	communication = "communication",
	price_change = "price_change",
	our_service = "our_service"
};

export enum ClaimSolutionEnum {
	original_partner = "original_partner",
	discount = "discount",
	replace_partner = "replace_partner",
	replace_partner_with_discount = "replace_partner_with_discount"
};

export type OrderClaimDetailResponseDto = {
	id: number;
	orderId: number;
	status: ClaimStatusEnum;
	type: ClaimTypeEnum;
	fee?: number | null;
	description?: string | null;
	finalSolution: ClaimSolutionEnum;
	dateNextAction?: string | null;
	dateCreated: string;
	dateUpdated: string;
	dateResolved?: string | null;
	partnerId: number;
	partner: PartnerGeneralResponseDto;
	verticalId?: number | null;
};

export type OrderSummaryFieldResponseDto = {
	label: string;
	value: string;
	comment?: string | null;
};

export type OrderSummarySectionResponseDto = {
	label: string;
	fields: OrderSummaryFieldResponseDto[];
};

export type OrderSummaryResponseDto = {
	sections: OrderSummarySectionResponseDto[];
	disclaimers?: string[] | null;
	notes?: string | null;
};

export type OrderDetailResponseDto = {
	id: number;
	dateCreated: string;
	dateUpdated: string;
	status: OrderStatus;
	customer: CustomerResponseDto;
	partner?: PartnerGeneralResponseDto | null;
	dateNextAction?: string | null;
	address?: string | null;
	notes?: string | null;
	market?: MarketResponseDto | null;
	region?: MarketRegionResponseDto | null;
	marketRegionId?: number | null;
	invoiceId?: number | null;
	userId?: number | null;
	orderSetupId: number;
	verticalId: number;
	vertical?: OrderVerticalResponseDto | null;
	fields: OrderFieldValueResponseDto[];
	cancellationReason: OrderCancellationReasonEnum;
	followUpAgentStatus?: FollowUpAgentStatusEnum | null;
	dateStarting?: string | null;
	dateDone?: string | null;
	hasExamination: boolean;
	calls: OrderCallResponseDto[];
	emailNotifications: OrderEmailNotificationResponseDto[];
	claims: OrderClaimDetailResponseDto[];
	sfInvoicePeriod?: string | null;
	price?: number | null;
	materialPrice?: number | null;
	packageType?: OrderPackage | null;
	jobDurationDays?: number | null;
	effectiveJobDurationDays?: number | null;
	b2b?: string | null;
	promoCode?: string | null;
	summary?: OrderSummaryResponseDto | null;
};

export type CustomerCreateDto = {
	name: string;
	email: string;
	phone: string;
};

export type OrderFieldValueCreateDto = {
	key: string;
	value?: string | null;
};

export type OrderCreateDto = {
	webPrice?: number | null;
	marketRegionId: number;
	formSubmitDate?: string | null;
	address?: string | null;
	customer: CustomerCreateDto;
	notes?: string | null;
	utm_source?: string | null;
	utm_medium?: string | null;
	utm_content?: string | null;
	gclid?: string | null;
	fields: OrderFieldValueCreateDto[];
	verticalId: number;
	verticalSlug: string;
	materialPrice?: number | null;
	publicToken?: string | null;
	b2b?: string | null;
	promoCode?: string | null;
	followUpAgentStatus?: "agent_started" | "agent_completed" | "agent_abandoned" | "quote_scope_confirmed" | "quote_requested_changes" | "booking_deferred" | "booking_abandoned" | "booking_confirmed" | "booking_cancelled" | "quote_deferred" | "in_progress" | "completed" | "not_completed_panic" | "not_completed_timeout" | null;
};

export type OrderCreateResponseDto = {
	orderId: number;
	customerId: number;
};

export type OrderManualCreateDto = {
	marketId: number;
	marketRegionId: number;
	address: string;
	customer: CustomerCreateDto;
	verticalId: number;
};

export type OrderFollowUpAgentStatusUpdateDto = {
	followUpAgentStatus: FollowUpAgentStatusEnum;
};

export type OrderFieldValueUpdateDto = {
	orderFieldId: number;
	value?: string | null;
};

export type OrderUpdateDto = {
	status?: OrderStatus | null;
	dateStarting?: string | null;
	dateDone?: string | null;
	address?: string | null;
	partnerId?: number | null;
	notes?: string | null;
	dateNextAction?: string | null;
	marketRegionId?: number | null;
	fields?: OrderFieldValueUpdateDto[] | null;
	cancellationReason?: OrderCancellationReasonEnum | null;
	followUpAgentStatus?: FollowUpAgentStatusEnum | null;
	userId?: number | null;
	sfInvoicePeriod?: string | null;
	jobDurationDays?: number | null;
	packageType?: OrderPackage | null;
	price?: number | null;
	incrementCount: boolean;
};

export enum OrderPriceChangeReason {
	website_price = "website_price",
	manually_created_order = "manually_created_order",
	admin_price = "admin_price",
	customer_adjustements = "customer_adjustements",
	partner_adjustements = "partner_adjustements",
	discount = "discount",
	examination_adjustements = "examination_adjustements",
	follow_up_adjustements = "follow_up_adjustements",
	protocol_agreed_price = "protocol_agreed_price"
};

export type OrderPriceCreateDto = {
	price: number;
	materialPrice?: number | null;
	userId?: number | null;
	reason: OrderPriceChangeReason;
};

export type OrderPriceResponseDto = {
	id: number;
	orderId: number;
	price: number;
	reason: OrderPriceChangeReason;
	userId?: number | null;
	materialPrice?: number | null;
	totalPrice: number;
};

export type CompanyResponseDto = {
	id: number;
	name: string;
	email: string;
	phone: string;
	city: string;
	country: CountryEnum;
	street: string;
	buildingNumber: string;
	postCode: string;
	businessId: string;
	vatId?: string | null;
	dateCreated: string;
	invoiceDueDays: number;
};

export type CompanyCreateDto = {
	name: string;
	email: string;
	phone: string;
	city: string;
	country: string;
	street: string;
	buildingNumber: string;
	businessId: string;
	vatId?: string | null;
	postCode: string;
	invoiceDueDays?: number | null;
};

export type CompanyUpdateDto = {
	name?: string | null;
	email?: string | null;
	phone?: string | null;
	city?: string | null;
	country?: string | null;
	street?: string | null;
	buildingNumber?: string | null;
	postCode?: string | null;
	businessId?: string | null;
	vatId?: string | null;
	invoiceDueDays?: number | null;
};

export type CustomerUpdateDto = {
	name?: string | null;
	email?: string | null;
	phone?: string | null;
	invoicingName?: string | null;
	invoicingAddress?: string | null;
	businessId?: string | null;
};

export enum PartnerLevel {
	Bronze = "Bronze",
	Silver = "Silver",
	Gold = "Gold",
	Adam = "Adam"
};

export type PartnerVerticalLevelUpdateDto = {
	level: PartnerLevel;
};

export type PartnerFilterDto = {
	marketId?: number | null;
	name?: string | null;
	middleName?: string | null;
	surname?: string | null;
	email?: string | null;
	phone?: string | null;
	skills?: PartnerSkills[] | null;
	teamSize?: number | null;
	isCanTrainDay?: boolean | null;
	status?: PartnerStatus | null;
	query?: string | null;
	pageLimit?: number | null;
	pageIndex?: number | null;
	orderBy?: string | null;
	orderDirection?: OrderDirection | null;
	verticals?: string | null;
};

export enum PartnerAddressType {
	BILLING = "BILLING",
	PRIMARY = "PRIMARY"
};

export type PartnerAddressResponseDto = {
	id?: number | null;
	street?: string | null;
	buildingNumber?: string | null;
	postCode?: string | null;
	city?: string | null;
	country?: CountryEnum | null;
	type?: PartnerAddressType | null;
};

export type PartnerBillingProfileResponseDto = {
	id?: number | null;
	invoicingName: string;
	businessId?: string | null;
	vatId?: string | null;
	vatLiable?: boolean | null;
	type: string;
	birthCountry?: string | null;
	birthCity?: string | null;
	birthDate?: string | null;
	tin?: string | null;
	address?: PartnerAddressResponseDto | null;
};

export type PartnerServiceAreaResponseDto = {
	id: number;
	marketRegionId: number;
	originAddress: string;
	isPrimary: boolean;
	isActive: boolean;
	marketRegion: MarketRegionResponseDto;
};

export type PartnerBankAccountResponseDto = {
	id?: number | null;
	accountHolder: string;
	iban?: string | null;
	bic?: string | null;
};

export type OrderResponseDto = {
	id: number;
	dateCreated: string;
	dateNextAction: string;
	status: OrderStatus;
	dateDone: string;
	followUpAgentStatus?: FollowUpAgentStatusEnum | null;
	customerName: string;
	partnerName: string;
};

export type PartnerVerticalResponseDto = {
	id: number;
	name: string;
	iconPath: string;
	level: PartnerLevel;
};

export type PartnerResponseDto = {
	partner: PartnerGeneralResponseDto;
	billingProfile?: PartnerBillingProfileResponseDto[] | null;
	address?: PartnerAddressResponseDto[] | null;
	serviceAreas?: PartnerServiceAreaResponseDto[] | null;
	bankAccount?: PartnerBankAccountResponseDto[] | null;
	orderCount: number;
	orders?: OrderResponseDto[] | null;
	market?: MarketResponseDto | null;
	region?: MarketRegionResponseDto | null;
	profileLink?: string | null;
	verticals: PartnerVerticalResponseDto[];
};

export type PartnerListAllResponseDto = {
	data?: PartnerResponseDto[] | null;
	metaData?: PayloadMetaDataResponseDto | null;
};

export type PartnerServiceAreaDto = {
	marketRegionId: number;
	originAddress: string;
	isPrimary: boolean;
	isActive: boolean;
};

export type PartnerGeneralCreateDto = {
	name: string;
	middleName?: string | null;
	surname: string;
	email: string;
	phone: string;
	verticals: number[];
	teamSize?: number | null;
	isCanTrainDay?: boolean | null;
	skills?: PartnerSkills[] | null;
	marketId: number;
	marketRegionId: number;
	serviceAreas: PartnerServiceAreaDto[];
};

export type PartnerBillingProfileCreateDto = {
	invoicingName: string;
	businessId?: string | null;
	vatId?: string | null;
	vatLiable?: boolean | null;
	type: "individual" | "company";
	birthCountry?: string | null;
	birthCity?: string | null;
	birthDate?: string | null;
	tin?: string | null;
};

export type PartnerAddressCreateDto = {
	street?: string | null;
	buildingNumber?: string | null;
	postCode?: string | null;
	country?: CountryEnum | null;
	city?: string | null;
	type?: PartnerAddressType | null;
};

export type PartnerBankAccountCreateDto = {
	accountHolder: string;
	iban?: string | null;
	bic?: string | null;
};

export type PartnerCreateDto = {
	partner: PartnerGeneralCreateDto;
	billingProfile: PartnerBillingProfileCreateDto;
	address: PartnerAddressCreateDto;
	billingAddress?: PartnerAddressCreateDto | null;
	bankAccount: PartnerBankAccountCreateDto;
	isSameAddress: boolean;
};

export type PartnerGeneralUpdateDto = {
	name?: string | null;
	middleName?: string | null;
	surname?: string | null;
	email?: string | null;
	phone?: string | null;
	status?: PartnerStatus | null;
	skills?: PartnerSkills[] | null;
	verticals: number[];
	teamSize?: number | null;
	isCanTrainDay?: boolean | null;
	marketId: number;
	marketRegionId: number;
	serviceAreas: PartnerServiceAreaDto[];
	profileLink?: string | null;
};

export type PartnerOrderDetailResponseDto = {
	id: number;
	jobDurationDays?: number | null;
	effectiveJobDurationDays?: number | null;
	summary?: OrderSummaryResponseDto | null;
};

export type OrderBillingFeeResponseDto = {
	percentage: number;
	amount: number;
	vatAmount: number;
};

export type OrderBillingResponseDto = {
	orderId: number;
	netTotal: number;
	paid: number;
	remaining: number;
	currency?: string | null;
	charges: [][];
	adamFee?: OrderBillingFeeResponseDto | null;
	payouts: [][];
	expressFeePrice?: number | null;
};

export type UserListResponseDto = {
	id: number;
	externalId: string;
	name: string;
	surname: string;
	email: string;
	nickname?: string | null;
	publicPhoneNumber?: string | null;
	avatarFileName?: string | null;
	preselectedMarketId: number;
	roles: string[];
};

export type UserDetailResponseDto = {
	id: number;
	externalId: string;
	name: string;
	surname: string;
	email: string;
	roles: string[];
	permissions: string[];
	preselectedMarketId: number;
	nickname?: string | null;
	publicPhoneNumber?: string | null;
	avatarFileName?: string | null;
};

export type UserUpdateDto = {
	name?: string | null;
	surname?: string | null;
	roles?: string[] | null;
	preselectedMarketId?: number | null;
};

export type File = {};

export type UserAvatarUploadDto = {
	avatarFile: File;
};

export enum InvoiceStatus {
	Pending = "Pending",
	Paid = "Paid",
	Cancelled = "Cancelled"
};

export type InvoiceFilterDto = {
	invoiceNumber?: string | null;
	variableSymbol?: string | null;
	status?: InvoiceStatus | null;
	partnerId?: number | null;
	marketId?: number | null;
	verticals?: string | null;
	pageLimit?: number | null;
	pageIndex?: number | null;
};

export enum InvoicePaymentType {
	Cash = "Cash",
	BankAccount = "BankAccount",
	Other = "Other"
};

export type InvoiceListResponseDto = {
	id: number;
	totalAmountWithVat: number;
	totalAmountWithoutVat: number;
	totalVatAmount: number;
	totalVatPercentage: number;
	totalDeposit: number;
	customerDebt: number;
	invoiceNumber: string;
	variableSymbol: string;
	status: InvoiceStatus;
	bankName: string;
	bankAccount: string;
	iban: string;
	paymentMethod: InvoicePaymentType;
	dateIssued: string;
	dateDue: string;
	datePaid?: string | null;
	supplierName: string;
	supplierBusinessId: string;
	supplierVatId: string;
	supplierVatLiable: boolean;
	supplierStreet: string;
	supplierBuildingNumber: string;
	supplierPostCode: string;
	supplierCity: string;
	customerName: string;
	customerBusinessId: string;
	customerVatId: string;
	customerVatLiable: boolean;
	customerStreet: string;
	customerBuildingNumber: string;
	customerPostCode: string;
	customerCity: string;
	order: OrderResponseDto;
	market?: MarketResponseDto | null;
	verticalId?: number | null;
};

export type InvoiceListAllResponseDto = {
	data: InvoiceListResponseDto[];
	metaData: PayloadMetaDataResponseDto;
};

export type InvoiceItemResponseDto = {
	id: number;
	name: string;
	count: number;
	pricePerUnit: number;
	totalPrice: number;
	vat: number;
	totalPriceVat: number;
};

export type InvoiceDetailResponseDto = {
	id: number;
	totalAmountWithVat: number;
	totalAmountWithoutVat: number;
	totalVatAmount: number;
	totalVatPercentage: number;
	totalDeposit: number;
	customerDebt: number;
	invoiceNumber: string;
	variableSymbol: string;
	status: InvoiceStatus;
	bankName: string;
	bankAccount: string;
	iban: string;
	paymentMethod: InvoicePaymentType;
	dateIssued: string;
	dateDue: string;
	datePaid?: string | null;
	supplierName: string;
	supplierBusinessId: string;
	supplierVatId: string;
	supplierVatLiable: boolean;
	supplierStreet: string;
	supplierBuildingNumber: string;
	supplierPostCode: string;
	supplierCity: string;
	customerName: string;
	customerBusinessId: string;
	customerVatId: string;
	customerVatLiable: boolean;
	customerStreet: string;
	customerBuildingNumber: string;
	customerPostCode: string;
	customerCity: string;
	items: InvoiceItemResponseDto[];
	market?: MarketResponseDto | null;
	order?: OrderResponseDto | null;
	partnerId: number;
	verticalId?: number | null;
};

export type InvoiceItemCreateDto = {
	name: string;
	count: number;
	pricePerUnit: number;
	totalPrice: number;
	vat: number;
	totalPriceVat: number;
};

export type InvoiceUpdateDto = {
	totalDeposit?: number | null;
	datePaid?: string | null;
	dateIssued?: string | null;
	dateDue?: string | null;
	supplierName?: string | null;
	supplierBusinessId?: string | null;
	supplierVatId?: string | null;
	supplierVatLiable?: boolean | null;
	supplierStreet?: string | null;
	supplierBuildingNumber?: string | null;
	supplierPostCode?: string | null;
	supplierCity?: string | null;
	customerName?: string | null;
	customerBusinessId?: string | null;
	customerVatId?: string | null;
	customerVatLiable?: boolean | null;
	customerStreet?: string | null;
	customerBuildingNumber?: string | null;
	customerPostCode?: string | null;
	customerCity?: string | null;
	items?: InvoiceItemCreateDto[] | null;
	status?: InvoiceStatus | null;
};

export type MarketCreateDto = {
	name: string;
	country: CountryEnum;
	currency: CurrencyEnum;
	webReferrer: string;
	urlPath: string;
	companyId: number;
	companyBankDetailId: number;
	timezone: string;
	isActive?: boolean | null;
};

export type MarketUpdateDto = {
	name?: string | null;
	country?: CountryEnum | null;
	currency?: CurrencyEnum | null;
	webReferrer?: string | null;
	companyId?: number | null;
	companyBankDetailId?: number | null;
	timezone?: string | null;
	b2bOptions?: string | null;
	isActive?: boolean | null;
};

export type OrderImportDto = {
	content?: File | null;
};

export enum BankTransactionType {
	inbound = "inbound",
	outbound = "outbound"
};

export type BankTransactionFilterDto = {
	query?: string | null;
	pageLimit?: number | null;
	pageIndex?: number | null;
	orderBy?: string | null;
	orderDirection?: OrderDirection | null;
	marketId?: number | null;
	type?: BankTransactionType | null;
	importedAt?: string | null;
	externalId?: string | null;
	createdAtFrom?: string | null;
	createdAtTo?: string | null;
	isRenovation?: boolean | null;
};

export enum Bank {
	fio = "fio",
	revolut = "revolut",
	raiffeisenbank = "raiffeisenbank"
};

export type CompanyBankDetailPaymentDto = {
	id: number;
	name: string;
	bankAccount: string;
	bankCode: string;
	bankName: Bank;
	iban: string;
};

export type BankTransactionDto = {
	id: number;
	externalId: string;
	reference: string;
	note: string;
	amount: number;
	currency: string;
	state: string;
	createdAt: string;
	updatedAt: string;
	bankDetails: CompanyBankDetailPaymentDto;
	marketId: number;
	isRenovation: boolean;
	orderId?: number | null;
};

export type BankTransactionListDto = {
	data: BankTransactionDto[];
	metaData: PayloadMetaDataResponseDto;
};

export type BankTransactionUpdateOrderDto = {
	id: number;
	orderId?: number | null;
	isRenovation?: boolean | null;
};

export enum PreferredAccountFormat {
	iban = "iban",
	bank_account_number = "bank_account_number"
};

export type CompanyBankDetailWithRelationsResponseDto = {
	id: number;
	name: string;
	bankAccount: string;
	bankCode: string;
	bankName: Bank;
	iban: string;
	preferredAccountFormat: PreferredAccountFormat;
	logoUrlPath: string;
	companyId: number;
	markets: MarketResponseDto[];
};

export type CompanyBankDetailResponseDto = {
	id: number;
	name: string;
	bankAccount: string;
	bankCode: string;
	bankName: Bank;
	iban: string;
	companyId: number;
	preferredAccountFormat: PreferredAccountFormat;
};

export type CompanyBankDetailCreateDto = {
	name: string;
	bankAccount: string;
	bankCode: string;
	bankName: Bank;
	iban: string;
	preferredAccountFormat: PreferredAccountFormat;
};

export type CompanyBankDetailUpdateDto = {
	name?: string | null;
	bankAccount?: string | null;
	bankCode?: string | null;
	bankName?: Bank | null;
	iban?: string | null;
	preferredAccountFormat?: PreferredAccountFormat | null;
};

export type PaintingServicesResponseDto = {
	total: number;
	isSkirting: number;
	isCleaning: number;
	isMoving: number;
	isCeiling: number;
	numShades: number;
	ceilingHeight: number;
	repairType: number;
	scraping: number;
	propertyType: number;
};

export type PaintingInteriorResponseDto = {
	total: number;
	rooms: number;
	features: number;
	sqm: number;
	services: PaintingServicesResponseDto;
	transportRate: number;
	paintPackage: number;
	minTotal: number;
};

export type PaintingWallpaperResponseDto = {
	total: number;
	install: number;
	removal: number;
	repair: number;
	transportRate: number;
};

export type PaintingResultResponseDto = {
	interior: PaintingInteriorResponseDto;
	wallpaper: PaintingWallpaperResponseDto;
};

export type ElectricianResultResponseDto = {
	work: number;
	revision: number;
	numSockets: number;
	numSwitches: number;
	numLights: number;
	chasingLength: number;
	socketRate: number;
	switchRate: number;
	lightRate: number;
	chasingRate: number;
};

export type FlooringResultResponseDto = {
	area: number;
	removal: number;
	preparation: number;
	installation: number;
	leveling: number;
	renoFloor: number;
	transportRate: number;
	moving: number;
};

export type RenovationResultResponseDto = {
	bathroom: number;
	tiling: number;
	disposition: number;
	plasterboard: number;
	plastering: number;
	flooring: number;
	electrician: number;
	painting: number;
};

export type OrderCalculatorResponseDto = {
	total: number;
	minimal: number;
	equipment: number;
	labor: number;
	packageType: string;
	transport: number;
	painting: PaintingResultResponseDto;
	electrician: ElectricianResultResponseDto;
	flooring: FlooringResultResponseDto;
	renovation: RenovationResultResponseDto;
};

export type OrderCallCreateDto = {
	type: OrderCallType;
	status: OrderCallStatus;
	operatorId: string;
};

export type OrderPhotoUploadDto = {
	photos: File[];
};

export type OrderPhotoResponseDto = {
	id: number;
	url: string;
	expiresAt?: string | null;
	mimeType: string;
	fileSizeBytes: number;
	originalFileName?: string | null;
	uploadedByUserId?: number | null;
	source: "customer" | "admin";
	dateCreated: string;
};

export type OrderEmailNotificationCreateDto = {
	type: OrderTypeNotification;
};

export type ClaimFilterDto = {
	marketId?: number | null;
	verticals?: string | null;
};

export type OrderClaimListResponseDto = {
	id: number;
	orderId: number;
	status: ClaimStatusEnum;
	type: ClaimTypeEnum;
	fee?: number | null;
	description?: string | null;
	finalSolution: ClaimSolutionEnum;
	dateNextAction?: string | null;
	dateCreated: string;
	dateUpdated: string;
	dateResolved?: string | null;
	partner: PartnerGeneralResponseDto;
	customerName: string;
	customerPhone: string;
	customerEmail: string;
	userFirstName: string;
	userLastName: string;
	verticalId?: number | null;
};

export type OrderClaimCreateDto = {
	orderId: number;
	status: ClaimStatusEnum;
	type: ClaimTypeEnum;
	fee?: number | null;
	description?: string | null;
	finalSolution?: ClaimSolutionEnum | null;
	dateNextAction?: string | null;
	dateResolved?: string | null;
};

export type OrderClaimUpdateDto = {
	status?: ClaimStatusEnum | null;
	partnerId?: number | null;
	type?: ClaimTypeEnum | null;
	fee?: number | null;
	description?: string | null;
	finalSolution?: ClaimSolutionEnum | null;
	dateNextAction?: string | null;
	dateResolved?: string | null;
};

export type CommentListResponseDto = {
	id: number;
	message: string;
	entityId: number;
	dateCreated: string;
	dateUpdated?: string | null;
	userId: number;
	userName: string;
	userSurname: string;
};

export type CommentCreateDto = {
	message: string;
};

export type CommentResponseDto = {
	id: number;
	message: string;
	entityId: number;
	userId: number;
	dateCreated: string;
	dateUpdated?: string | null;
};

export enum OrderPartnerAllocationSource {
	auto_offer = "auto_offer",
	manual = "manual",
	reallocation = "reallocation"
};

export enum OrderPartnerAllocationReason {
	manual_assignment = "manual_assignment",
	manual_unassignment = "manual_unassignment",
	manual_reallocation = "manual_reallocation",
	partner_rejected_assignment = "partner_rejected_assignment",
	auto_offer_accepted = "auto_offer_accepted",
	auto_offer_cancelled_queue_exhausted = "auto_offer_cancelled_queue_exhausted",
	workload_cap_override = "workload_cap_override"
};

export type OrderPartnerAllocationResponseDto = {
	id: number;
	orderId: number;
	partnerId: number;
	partner?: PartnerGeneralResponseDto | null;
	assignedAt: string;
	unassignedAt?: string | null;
	source: OrderPartnerAllocationSource;
	reason?: OrderPartnerAllocationReason | null;
	isCurrent: boolean;
};

export type OrderVerticalCreateDto = {
	name: string;
	iconPath: string;
};

export type OrderVerticalUpdateDto = {
	name?: string | null;
	iconPath?: string | null;
};

export enum OrderSetupStatusEnum {
	draft = "draft",
	ready = "ready",
	deployed = "deployed"
};

export type OrderSetupListResponseDto = {
	id: number;
	name: string;
	marketId: number;
	verticalId: number;
	status: OrderSetupStatusEnum;
};

export type OrderSetupDetailResponseDto = {
	id: number;
	name: string;
	market: MarketResponseDto;
	vertical: OrderVerticalResponseDto;
	status: OrderSetupStatusEnum;
	orderFields: OrderFieldResponseDto[];
	isLocked: boolean;
};

export type OrderFieldCreateDto = {
	key: string;
	label: string;
	type: OrderFieldTypeEnum;
	value?: string | null;
	orderIndex: number;
	emailLabel: string;
	isEmailIncluded: boolean;
};

export type OrderSetupCreateDto = {
	marketId: number;
	verticalId: number;
	status: OrderSetupStatusEnum;
	name?: string | null;
	orderFields?: OrderFieldCreateDto[] | null;
};

export type OrderSetupUpdateDto = {
	name?: string | null;
	status?: OrderSetupStatusEnum | null;
	orderFields?: OrderFieldCreateDto[] | null;
};

export enum OrderPaymentType {
	orderPayment = "orderPayment",
	orderDepositPayment = "orderDepositPayment",
	directPayment = "directPayment",
	partnerPayout = "partnerPayout"
};

export type OrderPaymentResponseDto = {
	id: number;
	orderId: number;
	type: OrderPaymentType;
	amount: number;
	dateCreated: string;
};

export type OrderPaymentCreateDto = {
	type: OrderPaymentType;
	amount: number;
	dateCreated: string;
};

export type CrossOrderNettingLineResponseDto = {
	orderId: number;
	partnerId: number;
	amount: number;
	description: string;
};

export type OrderPaymentDetailResponseDto = {
	id: number;
	orderId: number;
	totalDeposit?: number | null;
	totalPartnerPayout?: number | null;
	totalCustomerPayment?: number | null;
	partnerDue?: number | null;
	customerDebt?: number | null;
	recoveredFrom: CrossOrderNettingLineResponseDto[];
	deductions: CrossOrderNettingLineResponseDto[];
};

export type OrderFeeResponseDto = {
	id: number;
	orderId: number;
	serviceFeePercentage: number;
	serviceFeeAmount: number;
	serviceFeeVATPercentage: number;
	serviceVATAmount: number;
	customerVATPercentage: number;
	customerVATAmount: number;
	depositPercentage: number;
	depositRequirementAmount: number;
	serviceFeeDiscountPercentage: number;
	serviceFeeDiscountAmount: number;
	serviceFeeDiscountAmountVat: number;
	currentServiceFeePercentage: number;
};

export type OrderFeeUpdateDto = {
	serviceFeePercentage?: number | null;
	serviceFeeVATPercentage?: number | null;
	customerVATPercentage?: number | null;
	depositPercentage?: number | null;
	serviceFeeDiscountPercentage?: number | null;
};

export enum OrderChargeType {
	express_payment = "express_payment",
	behaviour_to_customer = "behaviour_to_customer",
	behaviour_to_adam = "behaviour_to_adam",
	connecting_with_customer = "connecting_with_customer",
	agreed_details = "agreed_details",
	order_form = "order_form",
	communication = "communication",
	delaying_jobs = "delaying_jobs",
	claim = "claim",
	other = "other"
};

export type OrderChargeResponseDto = {
	id: number;
	orderId: number;
	partnerId?: number | null;
	orderPartnerSettlementId?: number | null;
	type: OrderChargeType;
	amount: number;
	dateCreated: string;
};

export type OrderChargeCreateDto = {
	type: OrderChargeType;
	amount: number;
	partnerId?: number | null;
	dateCreated: string;
};

export type OrderChargeUpdateDto = {
	type?: OrderChargeType | null;
	amount?: number | null;
	partnerId?: number | null;
};

export type OrderExaminationCreateDto = {
	orderId: number;
	examinationDate: string;
};

export enum OrderExaminationStatus {
	pending = "pending",
	done = "done"
};

export type OrderExaminationResponseDto = {
	id: number;
	partnerId?: number | null;
	orderId: number;
	status: OrderExaminationStatus;
	examinationDate?: string | null;
	result?: string | null;
};

export type OrderExaminationUpdateDto = {
	partnerId?: number | null;
	status?: OrderExaminationStatus | null;
	examinationDate?: string | null;
	result?: string | null;
};

export type OrderExaminationResultDto = {
	result: string;
};

export type PartnerReviewResponseDto = {
	id: number;
	orderId: number;
	partnerId: number;
	rating?: OrderPartnerReviewRatingEnum | null;
	description?: string | null;
};

export type PartnerReviewCreateDto = {
	partnerId: number;
	rating: OrderPartnerReviewRatingEnum;
	description: string;
};

export type PartnerReviewUpdateDto = {
	partnerId?: number | null;
	rating?: OrderPartnerReviewRatingEnum | null;
	description?: string | null;
};

export enum OrdertimelineEntityEnum {
	order_history = "order_history",
	order_price = "order_price",
	order = "order",
	partner = "partner"
};

export enum OrderTimelineKeyEnum {
	status = "status",
	partnerId = "partnerId",
	price = "price"
};

export type OrderTimelineResponseDto = {
	id: number;
	orderId: number;
	entityId: number;
	entity: OrdertimelineEntityEnum;
	dateCreated: string;
	userId?: number | null;
	key?: OrderTimelineKeyEnum | null;
	description?: string | null;
	valueFrom?: string | null;
	valueTo?: string | null;
	user?: UserDetailResponseDto | null;
};

export type ProtocolDocumentMoneyDto = {
	amount: number;
	formatted: string;
};

export type ProtocolDocumentNoteDto = {
	stage: "start" | "handover";
	text: string;
};

export type ProtocolDocumentCustomerDto = {
	kind: "accepted" | "automatic" | "pending" | "declined";
	at?: string | null;
	atFormatted?: string | null;
	name?: string | null;
};

export type ProtocolDocumentStageDto = {
	status: "draft" | "sent" | "accepted" | "declined";
	partnerAcceptedAt?: string | null;
	partnerAcceptedAtFormatted?: string | null;
	customer: ProtocolDocumentCustomerDto;
	comment?: string | null;
};

export type ProtocolDocumentChecklistItemDto = {
	key: string;
	label: string;
	checked: boolean;
};

export type ProtocolDocumentResponseDto = {
	orderId: number;
	partnerName: string;
	customerName?: string | null;
	workAddress?: string | null;
	currency: string;
	badge: "accepted" | "autoAccepted" | "pending" | "declined";
	finalPrice?: ProtocolDocumentMoneyDto | null;
	originalEstimate?: ProtocolDocumentMoneyDto | null;
	notes: ProtocolDocumentNoteDto[];
	start?: ProtocolDocumentStageDto | null;
	handover?: ProtocolDocumentStageDto | null;
	checklist: ProtocolDocumentChecklistItemDto[];
};

export type SaveProtocolDto = {};

export type CustomerDecisionDto = {};

export type PartnerAvailabilityResponseDto = {
	id: number;
	partnerId: number;
	date: string;
	status: string;
	dateUpdated: string;
	dateCreated: string;
	isBlocked: boolean;
};

export type PartnerAvailabilityCreateDto = {};

export type PartnerAvailabilityUpdateItemDto = {
	partnerId: number;
	date: string;
	status: "available" | "not_available" | "job_with_adam";
	orderId?: number | null;
};

export type PartnerAvailabilityBulkUpdateDto = {
	items: PartnerAvailabilityUpdateItemDto[];
};

export type PartnerCalendarRequestDto = {
	marketId: number;
	startDate: string;
	endDate: string;
	page: number;
	limit: number;
	verticalIds?: number[] | null;
	regions?: number[] | null;
	skills?: ("WALLPAPERING" | "EXTERIOR_PAINTING" | "INTERIOR_PAINTING" | "INTERIOR_PAINTING_PREMIUM" | "PLUMBING" | "TILING" | "PLASTERBOARDS" | "PLASTERING" | "REWIRING" | "REVISION" | "PARQUET" | "PARQUET_RENO" | "CARPET" | "LINO" | "VINYL" | "HANDYMAN")[] | null;
};

export type PartnerCalendarVerticalDto = {
	name: string;
	level: "Bronze" | "Silver" | "Gold" | "Adam";
};

export type PartnerCalendarBookingDto = {
	orderId: number;
	orderPrice: number;
	duration: number;
	dayOfJob: number;
};

export type PartnerCalendarDayDto = {
	date: string;
	status: "available" | "not_available" | "job_with_adam";
	isBlocked: boolean;
	capacity: number;
	bookings: PartnerCalendarBookingDto[];
};

export type PartnerCalendarPartnerDto = {
	id: number;
	name: string;
	email: string;
	phone: string;
	verticals: PartnerCalendarVerticalDto[];
	confirmedJobsCount: number;
	inProgressJobsCount: number;
	calendar: PartnerCalendarDayDto[];
};

export type PartnerCalendarResponseDto = {
	total: number;
	page: number;
	limit: number;
	partners: PartnerCalendarPartnerDto[];
};

export type FindAvailablePartnersRequestDto = {
	orderId: number;
	startDate: string;
};

export type AvailablePartnerResponseDto = {
	id: number;
	name: string;
	middleName?: string | null;
	surname: string;
	fullName: string;
	email: string;
	phone: string;
	level: PartnerLevel;
	skills: PartnerSkills[];
	teamSize: number;
	inProgressCount: number;
	confirmedCount: number;
	score: number;
	drivingDistanceKm?: number | null;
};

export type FindAvailablePartnersResponseDto = {
	durationDays: number;
	detectedSkills: PartnerSkills[];
	partners: AvailablePartnerResponseDto[];
};

export type CreateOfferRequestDto = {
	orderId: number;
	startDate: string;
};

export enum OfferStatus {
	pending = "pending",
	accepted = "accepted",
	cancelled = "cancelled"
};

export type PartnerOfferResponseDto = {
	id: number;
	orderId: number;
	partnerId: number;
	startDate: string;
	rank: number;
	status: OfferStatus;
	dateCreated: string;
};

export type TriggerAllocationFlowRequestDto = {
	forceReallocation: boolean;
};

export enum ManualAllocationFlowStatus {
	created = "created",
	already_allocated = "already_allocated",
	skipped = "skipped"
};

export type ManualAllocationFlowResponseDto = {
	status: ManualAllocationFlowStatus;
	partnerId: number;
	offers: PartnerOfferResponseDto[];
};

export type RejectOrderAssignmentRequestDto = {
	partnerId: number;
};

export type RejectOrderAssignmentResponseDto = {
	chargeCreated: boolean;
	charge: OrderChargeResponseDto;
	offers: PartnerOfferResponseDto[];
};

export type OrderFieldLookupResponseDto = {
	id: number;
	key: string;
	label: string;
	type: string;
	value?: string | null;
	orderIndex?: number | null;
	orderSetupId?: number | null;
	dateCreated: string;
	dateUpdated: string;
	mappedFrom: string;
};

export type OrderFieldMappingsResponseDto = {
	mappings: unknown;
	count: number;
};

export type MarketRegionFilterDto = {
	isDeleted: boolean;
	name: string;
	timezone: string;
};

export type MarketRegionsCreateDto = {
	name: string;
	regionCode?: string | null;
	timezone?: string | null;
};

export type MarketRegionsUpdateDto = {
	name?: string | null;
	regionCode?: string | null;
	isDeleted?: boolean | null;
	timezone?: string | null;
};

export type VerticalGeneralSetupResponseDto = {
	id: number;
	adamServiceFeePercentage?: number | null;
	adamServiceFeeVATPercentage?: number | null;
	customerVATPercentage?: number | null;
	depositPercentage?: number | null;
	depositLimitAmount?: number | null;
	staticDepositAmount?: number | null;
	expresFeePrice?: number | null;
	emailReplyTo?: string | null;
	marketId: number;
	verticalId: number;
	dailyThreshold?: number | null;
	allocationMaxDrivingDistanceKm?: number | null;
};

export type VerticalGeneralSetupUpdateDto = {
	adamServiceFeePercentage?: number | null;
	adamServiceFeeVATPercentage?: number | null;
	customerVATPercentage?: number | null;
	depositPercentage?: number | null;
	depositLimitAmount?: number | null;
	staticDepositAmount?: number | null;
	expresFeePrice?: number | null;
	emailReplyTo?: string | null;
	dailyThreshold?: number | null;
	allocationMaxDrivingDistanceKm?: number | null;
};

export type PartnerScoreResponseDto = {
	internalScore: number;
	ratingScore: number;
	acceptanceScore: number;
	claimScore: number;
	rejectionScore: number;
	rawRating: number;
	rawAcceptanceRate: number;
	rawClaimRate: number;
	rawRejectionRate: number;
	rejectionCount: number;
};

export type PartnerAddressUpdateDto = {
	id?: number | null;
	street?: string | null;
	buildingNumber?: string | null;
	postCode?: string | null;
	country?: CountryEnum | null;
	city?: string | null;
	type?: PartnerAddressType | null;
};

export type PartnerBillingProfileUpdateDto = {
	invoicingName?: string | null;
	businessId?: string | null;
	vatId?: string | null;
	vatLiable?: boolean | null;
	type: "individual" | "company";
	birthCountry?: string | null;
	birthCity?: string | null;
	birthDate?: string | null;
	tin?: string | null;
	address?: PartnerAddressUpdateDto | null;
};

export enum PartnerBankAccountStatus {
	ACTIVE = "ACTIVE",
	INACTIVE = "INACTIVE",
	DELETED = "DELETED"
};

export type PartnerBankAccountUpdateDto = {
	accountHolder?: string | null;
	iban?: string | null;
	bic?: string | null;
	status?: PartnerBankAccountStatus | null;
};

export type PartnerKeyStatisticsFilterDto = {
	regionId?: number | null;
	marketId?: number | null;
};

export type PartnerKeyStatisticResponseDto = {
	partnerId: number;
	partnerName: string;
	openClaims: number;
	totalClaims: number;
	ordersDone: number;
	ordersConfirmed: number;
	ordersInProgress: number;
	ordersCancelled: number;
};

export enum PartnerBalanceType {
	order_done = "order_done",
	partner_payout = "partner_payout",
	claim_created = "claim_created",
	claim_resolved = "claim_resolved",
	fee = "fee",
	charge = "charge",
	manual = "manual"
};

export type PartnerBalanceTransactionResponseDto = {
	id: number;
	partnerId: number;
	orderId?: number | null;
	issuedById?: number | null;
	type: PartnerBalanceType;
	amount: number;
	vat: number;
	description?: string | null;
	dateCreated: string;
	dateUpdated: string;
	monthTag: string;
};

export type PartnerBalanceTransactionManualCreateDto = {
	orderId?: number | null;
	description?: string | null;
	amount: number;
};

export type UserRoleResponseDto = {
	name: string;
	permissions: string[];
};

export type UserRoleCreateDto = {
	name: string;
	permissions: string[];
};

export type UserRoleUpdateDto = {
	name: string;
	permissions?: string[] | null;
};

export type GetHealthFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<void, 503> 
| ErrorResponse;

export const getHealthPath = () => `/health`;

export const getHealth = (headers = new Headers()):
  Promise<GetHealthFetchResponse> => {
    return apiGet(`${getApiUrl()}${getHealthPath()}`, headers, {}) as Promise<GetHealthFetchResponse>;
}

export type GetHealthReadyFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<void, 503> 
| ErrorResponse;

export const getHealthReadyPath = () => `/health/ready`;

export const getHealthReady = (headers = new Headers()):
  Promise<GetHealthReadyFetchResponse> => {
    return apiGet(`${getApiUrl()}${getHealthReadyPath()}`, headers, {}) as Promise<GetHealthReadyFetchResponse>;
}

export type GetHealthLiveFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<void, 503> 
| ErrorResponse;

export const getHealthLivePath = () => `/health/live`;

export const getHealthLive = (headers = new Headers()):
  Promise<GetHealthLiveFetchResponse> => {
    return apiGet(`${getApiUrl()}${getHealthLivePath()}`, headers, {}) as Promise<GetHealthLiveFetchResponse>;
}

export type GetHealthStartupFetchResponse = 
| FetchResponse<void, 200> 
| FetchResponse<void, 503> 
| ErrorResponse;

export const getHealthStartupPath = () => `/health/startup`;

export const getHealthStartup = (headers = new Headers()):
  Promise<GetHealthStartupFetchResponse> => {
    return apiGet(`${getApiUrl()}${getHealthStartupPath()}`, headers, {}) as Promise<GetHealthStartupFetchResponse>;
}

export type GetOrdersUpdatePaymentDetailManuallyOrderIdFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const getOrdersUpdatePaymentDetailManuallyOrderIdPath = (orderId: number) => `/orders/update-payment-detail-manually/${orderId}`;

export const getOrdersUpdatePaymentDetailManuallyOrderId = (orderId: number, headers = new Headers()):
  Promise<GetOrdersUpdatePaymentDetailManuallyOrderIdFetchResponse> => {
    return apiGet(`${getApiUrl()}${getOrdersUpdatePaymentDetailManuallyOrderIdPath(orderId)}`, headers, {}) as Promise<GetOrdersUpdatePaymentDetailManuallyOrderIdFetchResponse>;
}

export type GetOrdersAgentIdFetchResponse = 
| FetchResponse<OrderAgentResponseDto, 200> 
| ErrorResponse;

export const getOrdersAgentIdPath = (id: number) => `/orders/agent/${id}`;

export const getOrdersAgentId = (id: number, headers = new Headers()):
  Promise<GetOrdersAgentIdFetchResponse> => {
    return apiGet(`${getApiUrl()}${getOrdersAgentIdPath(id)}`, headers, {}) as Promise<GetOrdersAgentIdFetchResponse>;
}

export type GetOrdersPublicTokenFetchResponse = 
| FetchResponse<OrderPublicResponseDto, 200> 
| ErrorResponse;

export const getOrdersPublicTokenPath = (token: string) => `/orders/public/${token}`;

export const getOrdersPublicToken = (token: string, headers = new Headers()):
  Promise<GetOrdersPublicTokenFetchResponse> => {
    return apiGet(`${getApiUrl()}${getOrdersPublicTokenPath(token)}`, headers, {}) as Promise<GetOrdersPublicTokenFetchResponse>;
}

export type PostOrdersSetAgentStatusFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const postOrdersSetAgentStatusPath = () => `/orders/set-agent-status`;

export const postOrdersSetAgentStatus = (headers = new Headers()):
  Promise<PostOrdersSetAgentStatusFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postOrdersSetAgentStatusPath()}`, requestData, headers) as Promise<PostOrdersSetAgentStatusFetchResponse>;
}

export type GetOrdersFetchResponse = 
| FetchResponse<OrderListAllResponseDto, 200> 
| ErrorResponse;

export const getOrdersPath = () => `/orders`;

export const getOrders = (status?: OrderStatus[], dateNextActionFrom?: string | undefined | null, dateNextActionTo?: string | undefined | null, dateStartingFrom?: string | undefined | null, dateStartingTo?: string | undefined | null, isNew?: boolean | undefined | null, isHasClaim?: boolean | undefined | null, marketId?: number | undefined | null, partnerId?: number | undefined | null, unassignedPartner?: boolean | undefined | null, regionId?: number | undefined | null, userId?: number | undefined | null, unassignedUser?: boolean | undefined | null, query?: string | undefined | null, pageLimit?: number | undefined | null, pageIndex?: number | undefined | null, isDeleted?: boolean | undefined | null, orderBy?: string | undefined | null, orderDirection?: OrderDirection, review?: OrderPartnerReviewRatingEnum, notReviewed?: boolean | undefined | null, hasExamination?: boolean | undefined | null, claimDateNextActionFrom?: string | undefined | null, claimDateNextActionTo?: string | undefined | null, verticals?: string | undefined | null, b2b?: string | undefined | null, promoCode?: string | undefined | null, followUpAgentStatus?: FollowUpAgentStatusEnum[], headers = new Headers()):
  Promise<GetOrdersFetchResponse> => {
    const queryParams = {
      "status": status,
      "dateNextActionFrom": dateNextActionFrom,
      "dateNextActionTo": dateNextActionTo,
      "dateStartingFrom": dateStartingFrom,
      "dateStartingTo": dateStartingTo,
      "isNew": isNew,
      "isHasClaim": isHasClaim,
      "marketId": marketId,
      "partnerId": partnerId,
      "unassignedPartner": unassignedPartner,
      "regionId": regionId,
      "userId": userId,
      "unassignedUser": unassignedUser,
      "query": query,
      "pageLimit": pageLimit,
      "pageIndex": pageIndex,
      "isDeleted": isDeleted,
      "orderBy": orderBy,
      "orderDirection": orderDirection,
      "review": review,
      "notReviewed": notReviewed,
      "hasExamination": hasExamination,
      "claimDateNextActionFrom": claimDateNextActionFrom,
      "claimDateNextActionTo": claimDateNextActionTo,
      "verticals": verticals,
      "b2b": b2b,
      "promoCode": promoCode,
      "followUpAgentStatus": followUpAgentStatus
    }
    return apiGet(`${getApiUrl()}${getOrdersPath()}`, headers, queryParams) as Promise<GetOrdersFetchResponse>;
}

export type PostOrdersFetchResponse = 
| FetchResponse<OrderCreateResponseDto, 200> 
| ErrorResponse;

export const postOrdersPath = () => `/orders`;

export const postOrders = (requestContract: OrderCreateDto, headers = new Headers()):
  Promise<PostOrdersFetchResponse> => {
    const requestData = getApiRequestData<OrderCreateDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postOrdersPath()}`, requestData, headers) as Promise<PostOrdersFetchResponse>;
}

export type GetOrdersMetaFetchResponse = 
| FetchResponse<OrderMetaResponseDto, 200> 
| ErrorResponse;

export const getOrdersMetaPath = () => `/orders/meta`;

export const getOrdersMeta = (status?: OrderStatus[], dateNextActionFrom?: string | undefined | null, dateNextActionTo?: string | undefined | null, dateStartingFrom?: string | undefined | null, dateStartingTo?: string | undefined | null, isNew?: boolean | undefined | null, isHasClaim?: boolean | undefined | null, marketId?: number | undefined | null, partnerId?: number | undefined | null, unassignedPartner?: boolean | undefined | null, regionId?: number | undefined | null, userId?: number | undefined | null, unassignedUser?: boolean | undefined | null, query?: string | undefined | null, pageLimit?: number | undefined | null, pageIndex?: number | undefined | null, isDeleted?: boolean | undefined | null, orderBy?: string | undefined | null, orderDirection?: OrderDirection, review?: OrderPartnerReviewRatingEnum, notReviewed?: boolean | undefined | null, hasExamination?: boolean | undefined | null, claimDateNextActionFrom?: string | undefined | null, claimDateNextActionTo?: string | undefined | null, verticals?: string | undefined | null, b2b?: string | undefined | null, promoCode?: string | undefined | null, followUpAgentStatus?: FollowUpAgentStatusEnum[], headers = new Headers()):
  Promise<GetOrdersMetaFetchResponse> => {
    const queryParams = {
      "status": status,
      "dateNextActionFrom": dateNextActionFrom,
      "dateNextActionTo": dateNextActionTo,
      "dateStartingFrom": dateStartingFrom,
      "dateStartingTo": dateStartingTo,
      "isNew": isNew,
      "isHasClaim": isHasClaim,
      "marketId": marketId,
      "partnerId": partnerId,
      "unassignedPartner": unassignedPartner,
      "regionId": regionId,
      "userId": userId,
      "unassignedUser": unassignedUser,
      "query": query,
      "pageLimit": pageLimit,
      "pageIndex": pageIndex,
      "isDeleted": isDeleted,
      "orderBy": orderBy,
      "orderDirection": orderDirection,
      "review": review,
      "notReviewed": notReviewed,
      "hasExamination": hasExamination,
      "claimDateNextActionFrom": claimDateNextActionFrom,
      "claimDateNextActionTo": claimDateNextActionTo,
      "verticals": verticals,
      "b2b": b2b,
      "promoCode": promoCode,
      "followUpAgentStatus": followUpAgentStatus
    }
    return apiGet(`${getApiUrl()}${getOrdersMetaPath()}`, headers, queryParams) as Promise<GetOrdersMetaFetchResponse>;
}

export type GetOrdersPartnerNamesFetchResponse = 
| FetchResponse<OrderPartnerNameResponseDto[], 200> 
| ErrorResponse;

export const getOrdersPartnerNamesPath = () => `/orders/partner-names`;

export const getOrdersPartnerNames = (orderIds: number[], headers = new Headers()):
  Promise<GetOrdersPartnerNamesFetchResponse> => {
    const queryParams = {
      "orderIds": orderIds
    }
    return apiGet(`${getApiUrl()}${getOrdersPartnerNamesPath()}`, headers, queryParams) as Promise<GetOrdersPartnerNamesFetchResponse>;
}

export type GetOrdersIdFetchResponse = 
| FetchResponse<OrderDetailResponseDto, 200> 
| ErrorResponse;

export const getOrdersIdPath = (id: number) => `/orders/${id}`;

export const getOrdersId = (id: number, headers = new Headers()):
  Promise<GetOrdersIdFetchResponse> => {
    return apiGet(`${getApiUrl()}${getOrdersIdPath(id)}`, headers, {}) as Promise<GetOrdersIdFetchResponse>;
}

export type DeleteOrdersIdFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const deleteOrdersIdPath = (id: number) => `/orders/${id}`;

export const deleteOrdersId = (id: number, headers = new Headers()):
  Promise<DeleteOrdersIdFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteOrdersIdPath(id)}`, headers, {}) as Promise<DeleteOrdersIdFetchResponse>;
}

export type PatchOrdersIdFetchResponse = 
| FetchResponse<OrderDetailResponseDto, 200> 
| ErrorResponse;

export const patchOrdersIdPath = (id: number) => `/orders/${id}`;

export const patchOrdersId = (requestContract: OrderUpdateDto, id: number, headers = new Headers()):
  Promise<PatchOrdersIdFetchResponse> => {
    const requestData = getApiRequestData<OrderUpdateDto>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchOrdersIdPath(id)}`, requestData, headers) as Promise<PatchOrdersIdFetchResponse>;
}

export type PostOrdersIdRegenerateInvoiceFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const postOrdersIdRegenerateInvoicePath = (id: number) => `/orders/${id}/regenerate-invoice`;

export const postOrdersIdRegenerateInvoice = (id: number, headers = new Headers()):
  Promise<PostOrdersIdRegenerateInvoiceFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postOrdersIdRegenerateInvoicePath(id)}`, requestData, headers) as Promise<PostOrdersIdRegenerateInvoiceFetchResponse>;
}

export type PostOrdersManualFetchResponse = 
| FetchResponse<OrderDetailResponseDto, 200> 
| ErrorResponse;

export const postOrdersManualPath = () => `/orders/manual`;

export const postOrdersManual = (requestContract: OrderManualCreateDto, headers = new Headers()):
  Promise<PostOrdersManualFetchResponse> => {
    const requestData = getApiRequestData<OrderManualCreateDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postOrdersManualPath()}`, requestData, headers) as Promise<PostOrdersManualFetchResponse>;
}

export type PatchOrdersIdFollowUpAgentStatusFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const patchOrdersIdFollowUpAgentStatusPath = (id: number) => `/orders/${id}/follow-up-agent-status`;

export const patchOrdersIdFollowUpAgentStatus = (requestContract: OrderFollowUpAgentStatusUpdateDto, id: number, headers = new Headers()):
  Promise<PatchOrdersIdFollowUpAgentStatusFetchResponse> => {
    const requestData = getApiRequestData<OrderFollowUpAgentStatusUpdateDto>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchOrdersIdFollowUpAgentStatusPath(id)}`, requestData, headers) as Promise<PatchOrdersIdFollowUpAgentStatusFetchResponse>;
}

export type PostOrdersIdPriceUpdateFetchResponse = 
| FetchResponse<OrderPriceResponseDto, 200> 
| ErrorResponse;

export const postOrdersIdPriceUpdatePath = (id: number) => `/orders/${id}/price/update`;

export const postOrdersIdPriceUpdate = (requestContract: OrderPriceCreateDto, id: number, headers = new Headers()):
  Promise<PostOrdersIdPriceUpdateFetchResponse> => {
    const requestData = getApiRequestData<OrderPriceCreateDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postOrdersIdPriceUpdatePath(id)}`, requestData, headers) as Promise<PostOrdersIdPriceUpdateFetchResponse>;
}

export type PostOrdersMarketIdManagerDiceFetchResponse = 
| FetchResponse<void, 201> 
| ErrorResponse;

export const postOrdersMarketIdManagerDicePath = (marketId: number) => `/orders/${marketId}/manager-dice`;

export const postOrdersMarketIdManagerDice = (marketId: number, headers = new Headers()):
  Promise<PostOrdersMarketIdManagerDiceFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postOrdersMarketIdManagerDicePath(marketId)}`, requestData, headers) as Promise<PostOrdersMarketIdManagerDiceFetchResponse>;
}

export type GetCompaniesFetchResponse = 
| FetchResponse<CompanyResponseDto[], 200> 
| ErrorResponse;

export const getCompaniesPath = () => `/companies`;

export const getCompanies = (headers = new Headers()):
  Promise<GetCompaniesFetchResponse> => {
    return apiGet(`${getApiUrl()}${getCompaniesPath()}`, headers, {}) as Promise<GetCompaniesFetchResponse>;
}

export type PostCompaniesFetchResponse = 
| FetchResponse<CompanyCreateDto, 200> 
| ErrorResponse;

export const postCompaniesPath = () => `/companies`;

export const postCompanies = (requestContract: CompanyCreateDto, headers = new Headers()):
  Promise<PostCompaniesFetchResponse> => {
    const requestData = getApiRequestData<CompanyCreateDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postCompaniesPath()}`, requestData, headers) as Promise<PostCompaniesFetchResponse>;
}

export type GetCompaniesIdFetchResponse = 
| FetchResponse<CompanyResponseDto, 200> 
| ErrorResponse;

export const getCompaniesIdPath = (id: number) => `/companies/${id}`;

export const getCompaniesId = (id: number, headers = new Headers()):
  Promise<GetCompaniesIdFetchResponse> => {
    return apiGet(`${getApiUrl()}${getCompaniesIdPath(id)}`, headers, {}) as Promise<GetCompaniesIdFetchResponse>;
}

export type PatchCompaniesIdFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const patchCompaniesIdPath = (id: number) => `/companies/${id}`;

export const patchCompaniesId = (requestContract: CompanyUpdateDto, id: number, headers = new Headers()):
  Promise<PatchCompaniesIdFetchResponse> => {
    const requestData = getApiRequestData<CompanyUpdateDto>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchCompaniesIdPath(id)}`, requestData, headers) as Promise<PatchCompaniesIdFetchResponse>;
}

export type GetCustomersIdFetchResponse = 
| FetchResponse<CustomerResponseDto, 200> 
| ErrorResponse;

export const getCustomersIdPath = (id: number) => `/customers/${id}`;

export const getCustomersId = (id: number, headers = new Headers()):
  Promise<GetCustomersIdFetchResponse> => {
    return apiGet(`${getApiUrl()}${getCustomersIdPath(id)}`, headers, {}) as Promise<GetCustomersIdFetchResponse>;
}

export type PatchCustomersIdFetchResponse = 
| FetchResponse<CustomerResponseDto, 200> 
| ErrorResponse;

export const patchCustomersIdPath = (id: number) => `/customers/${id}`;

export const patchCustomersId = (requestContract: CustomerUpdateDto, id: number, headers = new Headers()):
  Promise<PatchCustomersIdFetchResponse> => {
    const requestData = getApiRequestData<CustomerUpdateDto>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchCustomersIdPath(id)}`, requestData, headers) as Promise<PatchCustomersIdFetchResponse>;
}

export type PostCustomersFetchResponse = 
| FetchResponse<CustomerResponseDto, 200> 
| ErrorResponse;

export const postCustomersPath = () => `/customers`;

export const postCustomers = (requestContract: CustomerCreateDto, headers = new Headers()):
  Promise<PostCustomersFetchResponse> => {
    const requestData = getApiRequestData<CustomerCreateDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postCustomersPath()}`, requestData, headers) as Promise<PostCustomersFetchResponse>;
}

export type PatchPartnersIdVerticalsVerticalIdLevelFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const patchPartnersIdVerticalsVerticalIdLevelPath = (id: number, verticalId: number) => `/partners/${id}/verticals/${verticalId}/level`;

export const patchPartnersIdVerticalsVerticalIdLevel = (requestContract: PartnerVerticalLevelUpdateDto, id: number, verticalId: number, headers = new Headers()):
  Promise<PatchPartnersIdVerticalsVerticalIdLevelFetchResponse> => {
    const requestData = getApiRequestData<PartnerVerticalLevelUpdateDto>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchPartnersIdVerticalsVerticalIdLevelPath(id, verticalId)}`, requestData, headers) as Promise<PatchPartnersIdVerticalsVerticalIdLevelFetchResponse>;
}

export type GetPartnersFetchResponse = 
| FetchResponse<PartnerListAllResponseDto, 200> 
| ErrorResponse;

export const getPartnersPath = () => `/partners`;

export const getPartners = (marketId?: number | undefined | null, name?: string | undefined | null, middleName?: string | undefined | null, surname?: string | undefined | null, email?: string | undefined | null, phone?: string | undefined | null, skills?: PartnerSkills[], teamSize?: number | undefined | null, isCanTrainDay?: boolean | undefined | null, status?: PartnerStatus, query?: string | undefined | null, pageLimit?: number | undefined | null, pageIndex?: number | undefined | null, orderBy?: string | undefined | null, orderDirection?: OrderDirection, verticals?: string | undefined | null, headers = new Headers()):
  Promise<GetPartnersFetchResponse> => {
    const queryParams = {
      "marketId": marketId,
      "name": name,
      "middleName": middleName,
      "surname": surname,
      "email": email,
      "phone": phone,
      "skills": skills,
      "teamSize": teamSize,
      "isCanTrainDay": isCanTrainDay,
      "status": status,
      "query": query,
      "pageLimit": pageLimit,
      "pageIndex": pageIndex,
      "orderBy": orderBy,
      "orderDirection": orderDirection,
      "verticals": verticals
    }
    return apiGet(`${getApiUrl()}${getPartnersPath()}`, headers, queryParams) as Promise<GetPartnersFetchResponse>;
}

export type PostPartnersFetchResponse = 
| FetchResponse<PartnerResponseDto, 200> 
| ErrorResponse;

export const postPartnersPath = () => `/partners`;

export const postPartners = (requestContract: PartnerCreateDto, headers = new Headers()):
  Promise<PostPartnersFetchResponse> => {
    const requestData = getApiRequestData<PartnerCreateDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPartnersPath()}`, requestData, headers) as Promise<PostPartnersFetchResponse>;
}

export type GetPartnersIdFetchResponse = 
| FetchResponse<PartnerResponseDto, 200> 
| ErrorResponse;

export const getPartnersIdPath = (id: number) => `/partners/${id}`;

export const getPartnersId = (id: number, headers = new Headers()):
  Promise<GetPartnersIdFetchResponse> => {
    return apiGet(`${getApiUrl()}${getPartnersIdPath(id)}`, headers, {}) as Promise<GetPartnersIdFetchResponse>;
}

export type DeletePartnersIdFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const deletePartnersIdPath = (id: number) => `/partners/${id}`;

export const deletePartnersId = (id: number, headers = new Headers()):
  Promise<DeletePartnersIdFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deletePartnersIdPath(id)}`, headers, {}) as Promise<DeletePartnersIdFetchResponse>;
}

export type PatchPartnersIdFetchResponse = 
| FetchResponse<PartnerResponseDto, 200> 
| ErrorResponse;

export const patchPartnersIdPath = (id: number) => `/partners/${id}`;

export const patchPartnersId = (requestContract: PartnerGeneralUpdateDto, id: number, headers = new Headers()):
  Promise<PatchPartnersIdFetchResponse> => {
    const requestData = getApiRequestData<PartnerGeneralUpdateDto>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchPartnersIdPath(id)}`, requestData, headers) as Promise<PatchPartnersIdFetchResponse>;
}

export type PostPartnersIdRegisterPortalFetchResponse = 
| FetchResponse<{success: boolean;
	message: string;}, 200> 
| ErrorResponse;

export const postPartnersIdRegisterPortalPath = (id: number) => `/partners/${id}/register-portal`;

export const postPartnersIdRegisterPortal = (id: number, headers = new Headers()):
  Promise<PostPartnersIdRegisterPortalFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postPartnersIdRegisterPortalPath(id)}`, requestData, headers) as Promise<PostPartnersIdRegisterPortalFetchResponse>;
}

export type GetPartnersIdOrdersFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const getPartnersIdOrdersPath = (id: number) => `/partners/${id}/orders`;

export const getPartnersIdOrders = (id: number, status?: OrderStatus[], headers = new Headers()):
  Promise<GetPartnersIdOrdersFetchResponse> => {
    const queryParams = {
      "status": status
    }
    return apiGet(`${getApiUrl()}${getPartnersIdOrdersPath(id)}`, headers, queryParams) as Promise<GetPartnersIdOrdersFetchResponse>;
}

export type GetPartnersPartnerIdOrdersOrderIdFetchResponse = 
| FetchResponse<PartnerOrderDetailResponseDto, 200> 
| ErrorResponse;

export const getPartnersPartnerIdOrdersOrderIdPath = (partnerId: number, orderId: number) => `/partners/${partnerId}/orders/${orderId}`;

export const getPartnersPartnerIdOrdersOrderId = (partnerId: number, orderId: number, headers = new Headers()):
  Promise<GetPartnersPartnerIdOrdersOrderIdFetchResponse> => {
    return apiGet(`${getApiUrl()}${getPartnersPartnerIdOrdersOrderIdPath(partnerId, orderId)}`, headers, {}) as Promise<GetPartnersPartnerIdOrdersOrderIdFetchResponse>;
}

export type GetPartnersPartnerIdOrdersOrderIdBillingFetchResponse = 
| FetchResponse<OrderBillingResponseDto, 200> 
| ErrorResponse;

export const getPartnersPartnerIdOrdersOrderIdBillingPath = (partnerId: number, orderId: number) => `/partners/${partnerId}/orders/${orderId}/billing`;

export const getPartnersPartnerIdOrdersOrderIdBilling = (partnerId: number, orderId: number, headers = new Headers()):
  Promise<GetPartnersPartnerIdOrdersOrderIdBillingFetchResponse> => {
    return apiGet(`${getApiUrl()}${getPartnersPartnerIdOrdersOrderIdBillingPath(partnerId, orderId)}`, headers, {}) as Promise<GetPartnersPartnerIdOrdersOrderIdBillingFetchResponse>;
}

export type PostPartnersPartnerIdOrdersOrderIdExpressPayoutFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const postPartnersPartnerIdOrdersOrderIdExpressPayoutPath = (partnerId: number, orderId: number) => `/partners/${partnerId}/orders/${orderId}/express-payout`;

export const postPartnersPartnerIdOrdersOrderIdExpressPayout = (partnerId: number, orderId: number, headers = new Headers()):
  Promise<PostPartnersPartnerIdOrdersOrderIdExpressPayoutFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postPartnersPartnerIdOrdersOrderIdExpressPayoutPath(partnerId, orderId)}`, requestData, headers) as Promise<PostPartnersPartnerIdOrdersOrderIdExpressPayoutFetchResponse>;
}

export type PostNotificationsPartnersPushAvailabilityFetchResponse = 
| FetchResponse<void, 201> 
| ErrorResponse;

export const postNotificationsPartnersPushAvailabilityPath = () => `/notifications/partners/push/availability`;

export const postNotificationsPartnersPushAvailability = (headers = new Headers()):
  Promise<PostNotificationsPartnersPushAvailabilityFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postNotificationsPartnersPushAvailabilityPath()}`, requestData, headers) as Promise<PostNotificationsPartnersPushAvailabilityFetchResponse>;
}

export type PostNotificationsPartnersPushMorningFetchResponse = 
| FetchResponse<void, 201> 
| ErrorResponse;

export const postNotificationsPartnersPushMorningPath = () => `/notifications/partners/push/morning`;

export const postNotificationsPartnersPushMorning = (headers = new Headers()):
  Promise<PostNotificationsPartnersPushMorningFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postNotificationsPartnersPushMorningPath()}`, requestData, headers) as Promise<PostNotificationsPartnersPushMorningFetchResponse>;
}

export type GetUsersFetchResponse = 
| FetchResponse<UserListResponseDto[], 200> 
| ErrorResponse;

export const getUsersPath = () => `/users`;

export const getUsers = (headers = new Headers()):
  Promise<GetUsersFetchResponse> => {
    return apiGet(`${getApiUrl()}${getUsersPath()}`, headers, {}) as Promise<GetUsersFetchResponse>;
}

export type GetUsersProfileFetchResponse = 
| FetchResponse<UserDetailResponseDto, 200> 
| ErrorResponse;

export const getUsersProfilePath = () => `/users/profile`;

export const getUsersProfile = (headers = new Headers()):
  Promise<GetUsersProfileFetchResponse> => {
    return apiGet(`${getApiUrl()}${getUsersProfilePath()}`, headers, {}) as Promise<GetUsersProfileFetchResponse>;
}

export type GetUsersIdFetchResponse = 
| FetchResponse<UserDetailResponseDto, 200> 
| ErrorResponse;

export const getUsersIdPath = (id: number) => `/users/${id}`;

export const getUsersId = (id: number, headers = new Headers()):
  Promise<GetUsersIdFetchResponse> => {
    return apiGet(`${getApiUrl()}${getUsersIdPath(id)}`, headers, {}) as Promise<GetUsersIdFetchResponse>;
}

export type PatchUsersIdFetchResponse = 
| FetchResponse<UserDetailResponseDto, 200> 
| ErrorResponse;

export const patchUsersIdPath = (id: number) => `/users/${id}`;

export const patchUsersId = (requestContract: UserUpdateDto, id: number, headers = new Headers()):
  Promise<PatchUsersIdFetchResponse> => {
    const requestData = getApiRequestData<UserUpdateDto>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchUsersIdPath(id)}`, requestData, headers) as Promise<PatchUsersIdFetchResponse>;
}

export type PostUsersIdUploadAvatarFetchResponse = 
| FetchResponse<UserDetailResponseDto, 200> 
| ErrorResponse;

export const postUsersIdUploadAvatarPath = (id: number) => `/users/${id}/upload-avatar`;

export const postUsersIdUploadAvatar = (requestContract: UserAvatarUploadDto, id: number, headers = new Headers()):
  Promise<PostUsersIdUploadAvatarFetchResponse> => {
    const requestData = getApiRequestData<UserAvatarUploadDto>(requestContract, true);

    return apiPost(`${getApiUrl()}${postUsersIdUploadAvatarPath(id)}`, requestData, headers) as Promise<PostUsersIdUploadAvatarFetchResponse>;
}

export type GetUsersIdAvatarFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const getUsersIdAvatarPath = (id: number) => `/users/${id}/avatar`;

export const getUsersIdAvatar = (id: number, headers = new Headers()):
  Promise<GetUsersIdAvatarFetchResponse> => {
    return apiGet(`${getApiUrl()}${getUsersIdAvatarPath(id)}`, headers, {}) as Promise<GetUsersIdAvatarFetchResponse>;
}

export type GetInvoicesFetchResponse = 
| FetchResponse<InvoiceListAllResponseDto, 200> 
| ErrorResponse;

export const getInvoicesPath = () => `/invoices`;

export const getInvoices = (invoiceNumber?: string | undefined | null, variableSymbol?: string | undefined | null, status?: InvoiceStatus, partnerId?: number | undefined | null, marketId?: number | undefined | null, verticals?: string | undefined | null, pageLimit?: number | undefined | null, pageIndex?: number | undefined | null, headers = new Headers()):
  Promise<GetInvoicesFetchResponse> => {
    const queryParams = {
      "invoiceNumber": invoiceNumber,
      "variableSymbol": variableSymbol,
      "status": status,
      "partnerId": partnerId,
      "marketId": marketId,
      "verticals": verticals,
      "pageLimit": pageLimit,
      "pageIndex": pageIndex
    }
    return apiGet(`${getApiUrl()}${getInvoicesPath()}`, headers, queryParams) as Promise<GetInvoicesFetchResponse>;
}

export type GetInvoicesIdFetchResponse = 
| FetchResponse<InvoiceDetailResponseDto, 200> 
| ErrorResponse;

export const getInvoicesIdPath = (id: number) => `/invoices/${id}`;

export const getInvoicesId = (id: number, headers = new Headers()):
  Promise<GetInvoicesIdFetchResponse> => {
    return apiGet(`${getApiUrl()}${getInvoicesIdPath(id)}`, headers, {}) as Promise<GetInvoicesIdFetchResponse>;
}

export type PatchInvoicesIdFetchResponse = 
| FetchResponse<InvoiceDetailResponseDto, 200> 
| ErrorResponse;

export const patchInvoicesIdPath = (id: number) => `/invoices/${id}`;

export const patchInvoicesId = (requestContract: InvoiceUpdateDto, id: number, headers = new Headers()):
  Promise<PatchInvoicesIdFetchResponse> => {
    const requestData = getApiRequestData<InvoiceUpdateDto>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchInvoicesIdPath(id)}`, requestData, headers) as Promise<PatchInvoicesIdFetchResponse>;
}

export type GetInvoicesIdDownloadFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const getInvoicesIdDownloadPath = (id: number) => `/invoices/${id}/download`;

export const getInvoicesIdDownload = (id: number, headers = new Headers()):
  Promise<GetInvoicesIdDownloadFetchResponse> => {
    return apiGet(`${getApiUrl()}${getInvoicesIdDownloadPath(id)}`, headers, {}) as Promise<GetInvoicesIdDownloadFetchResponse>;
}

export type GetMarketsFetchResponse = 
| FetchResponse<MarketResponseDto[], 200> 
| ErrorResponse;

export const getMarketsPath = () => `/markets`;

export const getMarkets = (headers = new Headers()):
  Promise<GetMarketsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getMarketsPath()}`, headers, {}) as Promise<GetMarketsFetchResponse>;
}

export type PostMarketsFetchResponse = 
| FetchResponse<MarketResponseDto, 200> 
| ErrorResponse;

export const postMarketsPath = () => `/markets`;

export const postMarkets = (requestContract: MarketCreateDto, headers = new Headers()):
  Promise<PostMarketsFetchResponse> => {
    const requestData = getApiRequestData<MarketCreateDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postMarketsPath()}`, requestData, headers) as Promise<PostMarketsFetchResponse>;
}

export type GetMarketsUrlPathFetchResponse = 
| FetchResponse<MarketResponseDto, 200> 
| ErrorResponse;

export const getMarketsUrlPathPath = (urlPath: string) => `/markets/${urlPath}`;

export const getMarketsUrlPath = (urlPath: string, headers = new Headers()):
  Promise<GetMarketsUrlPathFetchResponse> => {
    return apiGet(`${getApiUrl()}${getMarketsUrlPathPath(urlPath)}`, headers, {}) as Promise<GetMarketsUrlPathFetchResponse>;
}

export type DeleteMarketsIdFetchResponse = 
| FetchResponse<void, 204> 
| ErrorResponse;

export const deleteMarketsIdPath = (id: number) => `/markets/${id}`;

export const deleteMarketsId = (id: number, headers = new Headers()):
  Promise<DeleteMarketsIdFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteMarketsIdPath(id)}`, headers, {}) as Promise<DeleteMarketsIdFetchResponse>;
}

export type PatchMarketsIdFetchResponse = 
| FetchResponse<MarketResponseDto, 200> 
| ErrorResponse;

export const patchMarketsIdPath = (id: number) => `/markets/${id}`;

export const patchMarketsId = (requestContract: MarketUpdateDto, id: number, headers = new Headers()):
  Promise<PatchMarketsIdFetchResponse> => {
    const requestData = getApiRequestData<MarketUpdateDto>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchMarketsIdPath(id)}`, requestData, headers) as Promise<PatchMarketsIdFetchResponse>;
}

export type PostOrdersMarketMarketIdVerticalVerticalIdImportCsvFetchResponse = 
| FetchResponse<void, 201> 
| ErrorResponse;

export const postOrdersMarketMarketIdVerticalVerticalIdImportCsvPath = (marketId: number) => `/orders/market/${marketId}/vertical/{verticalId}/import/csv`;

export const postOrdersMarketMarketIdVerticalVerticalIdImportCsv = (requestContract: OrderImportDto, marketId: number, headers = new Headers()):
  Promise<PostOrdersMarketMarketIdVerticalVerticalIdImportCsvFetchResponse> => {
    const requestData = getApiRequestData<OrderImportDto>(requestContract, true);

    return apiPost(`${getApiUrl()}${postOrdersMarketMarketIdVerticalVerticalIdImportCsvPath(marketId)}`, requestData, headers) as Promise<PostOrdersMarketMarketIdVerticalVerticalIdImportCsvFetchResponse>;
}

export type PostOrdersMarketMarketIdVerticalVerticalIdImportCsvCommentsFetchResponse = 
| FetchResponse<void, 201> 
| ErrorResponse;

export const postOrdersMarketMarketIdVerticalVerticalIdImportCsvCommentsPath = (marketId: number) => `/orders/market/${marketId}/vertical/{verticalId}/import/csv-comments`;

export const postOrdersMarketMarketIdVerticalVerticalIdImportCsvComments = (requestContract: OrderImportDto, marketId: number, headers = new Headers()):
  Promise<PostOrdersMarketMarketIdVerticalVerticalIdImportCsvCommentsFetchResponse> => {
    const requestData = getApiRequestData<OrderImportDto>(requestContract, true);

    return apiPost(`${getApiUrl()}${postOrdersMarketMarketIdVerticalVerticalIdImportCsvCommentsPath(marketId)}`, requestData, headers) as Promise<PostOrdersMarketMarketIdVerticalVerticalIdImportCsvCommentsFetchResponse>;
}

export type PostOrdersMarketMarketIdVerticalVerticalIdImportCsvRegionsFetchResponse = 
| FetchResponse<void, 201> 
| ErrorResponse;

export const postOrdersMarketMarketIdVerticalVerticalIdImportCsvRegionsPath = (marketId: number) => `/orders/market/${marketId}/vertical/{verticalId}/import/csv-regions`;

export const postOrdersMarketMarketIdVerticalVerticalIdImportCsvRegions = (requestContract: OrderImportDto, marketId: number, headers = new Headers()):
  Promise<PostOrdersMarketMarketIdVerticalVerticalIdImportCsvRegionsFetchResponse> => {
    const requestData = getApiRequestData<OrderImportDto>(requestContract, true);

    return apiPost(`${getApiUrl()}${postOrdersMarketMarketIdVerticalVerticalIdImportCsvRegionsPath(marketId)}`, requestData, headers) as Promise<PostOrdersMarketMarketIdVerticalVerticalIdImportCsvRegionsFetchResponse>;
}

export type PostOrdersMarketMarketIdVerticalVerticalIdImportCsvPriceFetchResponse = 
| FetchResponse<void, 201> 
| ErrorResponse;

export const postOrdersMarketMarketIdVerticalVerticalIdImportCsvPricePath = (marketId: number) => `/orders/market/${marketId}/vertical/{verticalId}/import/csv-price`;

export const postOrdersMarketMarketIdVerticalVerticalIdImportCsvPrice = (requestContract: OrderImportDto, marketId: number, headers = new Headers()):
  Promise<PostOrdersMarketMarketIdVerticalVerticalIdImportCsvPriceFetchResponse> => {
    const requestData = getApiRequestData<OrderImportDto>(requestContract, true);

    return apiPost(`${getApiUrl()}${postOrdersMarketMarketIdVerticalVerticalIdImportCsvPricePath(marketId)}`, requestData, headers) as Promise<PostOrdersMarketMarketIdVerticalVerticalIdImportCsvPriceFetchResponse>;
}

export type PostOrdersMarketMarketIdVerticalVerticalIdImportCsvPartnersFetchResponse = 
| FetchResponse<void, 201> 
| ErrorResponse;

export const postOrdersMarketMarketIdVerticalVerticalIdImportCsvPartnersPath = (marketId: number) => `/orders/market/${marketId}/vertical/{verticalId}/import/csv-partners`;

export const postOrdersMarketMarketIdVerticalVerticalIdImportCsvPartners = (requestContract: OrderImportDto, marketId: number, headers = new Headers()):
  Promise<PostOrdersMarketMarketIdVerticalVerticalIdImportCsvPartnersFetchResponse> => {
    const requestData = getApiRequestData<OrderImportDto>(requestContract, true);

    return apiPost(`${getApiUrl()}${postOrdersMarketMarketIdVerticalVerticalIdImportCsvPartnersPath(marketId)}`, requestData, headers) as Promise<PostOrdersMarketMarketIdVerticalVerticalIdImportCsvPartnersFetchResponse>;
}

export type PostOrdersMarketMarketIdVerticalVerticalIdImportCsvUtmFetchResponse = 
| FetchResponse<void, 201> 
| ErrorResponse;

export const postOrdersMarketMarketIdVerticalVerticalIdImportCsvUtmPath = (marketId: number) => `/orders/market/${marketId}/vertical/{verticalId}/import/csv-utm`;

export const postOrdersMarketMarketIdVerticalVerticalIdImportCsvUtm = (requestContract: OrderImportDto, marketId: number, headers = new Headers()):
  Promise<PostOrdersMarketMarketIdVerticalVerticalIdImportCsvUtmFetchResponse> => {
    const requestData = getApiRequestData<OrderImportDto>(requestContract, true);

    return apiPost(`${getApiUrl()}${postOrdersMarketMarketIdVerticalVerticalIdImportCsvUtmPath(marketId)}`, requestData, headers) as Promise<PostOrdersMarketMarketIdVerticalVerticalIdImportCsvUtmFetchResponse>;
}

export type GetOrdersOrderIdPriceListFetchResponse = 
| FetchResponse<OrderPriceResponseDto[], 200> 
| ErrorResponse;

export const getOrdersOrderIdPriceListPath = (orderId: number) => `/orders/${orderId}/price/list`;

export const getOrdersOrderIdPriceList = (orderId: number, headers = new Headers()):
  Promise<GetOrdersOrderIdPriceListFetchResponse> => {
    return apiGet(`${getApiUrl()}${getOrdersOrderIdPriceListPath(orderId)}`, headers, {}) as Promise<GetOrdersOrderIdPriceListFetchResponse>;
}

export type GetOrdersOrderIdPriceFetchResponse = 
| FetchResponse<OrderPriceResponseDto, 200> 
| ErrorResponse;

export const getOrdersOrderIdPricePath = (orderId: number) => `/orders/${orderId}/price`;

export const getOrdersOrderIdPrice = (orderId: number, headers = new Headers()):
  Promise<GetOrdersOrderIdPriceFetchResponse> => {
    return apiGet(`${getApiUrl()}${getOrdersOrderIdPricePath(orderId)}`, headers, {}) as Promise<GetOrdersOrderIdPriceFetchResponse>;
}

export type PostOrdersOrderIdPriceFetchResponse = 
| FetchResponse<OrderPriceResponseDto, 200> 
| ErrorResponse;

export const postOrdersOrderIdPricePath = (orderId: number) => `/orders/${orderId}/price`;

export const postOrdersOrderIdPrice = (requestContract: OrderPriceCreateDto, orderId: number, headers = new Headers()):
  Promise<PostOrdersOrderIdPriceFetchResponse> => {
    const requestData = getApiRequestData<OrderPriceCreateDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postOrdersOrderIdPricePath(orderId)}`, requestData, headers) as Promise<PostOrdersOrderIdPriceFetchResponse>;
}

export type PatchOrdersOrderIdPricePriceIdFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const patchOrdersOrderIdPricePriceIdPath = (orderId: number, priceId: number) => `/orders/${orderId}/price/${priceId}`;

export const patchOrdersOrderIdPricePriceId = (requestContract: OrderPriceCreateDto, orderId: number, priceId: number, headers = new Headers()):
  Promise<PatchOrdersOrderIdPricePriceIdFetchResponse> => {
    const requestData = getApiRequestData<OrderPriceCreateDto>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchOrdersOrderIdPricePriceIdPath(orderId, priceId)}`, requestData, headers) as Promise<PatchOrdersOrderIdPricePriceIdFetchResponse>;
}

export type GetBanksTransactionsFetchResponse = 
| FetchResponse<BankTransactionListDto, 200> 
| ErrorResponse;

export const getBanksTransactionsPath = () => `/banks/transactions`;

export const getBanksTransactions = (query?: string | undefined | null, pageLimit?: number | undefined | null, pageIndex?: number | undefined | null, orderBy?: string | undefined | null, orderDirection?: OrderDirection, marketId?: number | undefined | null, type?: BankTransactionType, importedAt?: string | undefined | null, externalId?: string | undefined | null, createdAtFrom?: string | undefined | null, createdAtTo?: string | undefined | null, isRenovation?: boolean | undefined | null, headers = new Headers()):
  Promise<GetBanksTransactionsFetchResponse> => {
    const queryParams = {
      "query": query,
      "pageLimit": pageLimit,
      "pageIndex": pageIndex,
      "orderBy": orderBy,
      "orderDirection": orderDirection,
      "marketId": marketId,
      "type": type,
      "importedAt": importedAt,
      "externalId": externalId,
      "createdAtFrom": createdAtFrom,
      "createdAtTo": createdAtTo,
      "isRenovation": isRenovation
    }
    return apiGet(`${getApiUrl()}${getBanksTransactionsPath()}`, headers, queryParams) as Promise<GetBanksTransactionsFetchResponse>;
}

export type PatchBanksTransactionsIdFetchResponse = 
| FetchResponse<BankTransactionDto, 200> 
| ErrorResponse;

export const patchBanksTransactionsIdPath = (id: number) => `/banks/transactions/${id}`;

export const patchBanksTransactionsId = (requestContract: BankTransactionUpdateOrderDto, id: number, headers = new Headers()):
  Promise<PatchBanksTransactionsIdFetchResponse> => {
    const requestData = getApiRequestData<BankTransactionUpdateOrderDto>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchBanksTransactionsIdPath(id)}`, requestData, headers) as Promise<PatchBanksTransactionsIdFetchResponse>;
}

export type PostServiceInvoicesCreateFetchResponse = 
| FetchResponse<void, 201> 
| ErrorResponse;

export const postServiceInvoicesCreatePath = () => `/service-invoices/create`;

export const postServiceInvoicesCreate = (headers = new Headers()):
  Promise<PostServiceInvoicesCreateFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postServiceInvoicesCreatePath()}`, requestData, headers) as Promise<PostServiceInvoicesCreateFetchResponse>;
}

export type PostServiceInvoicesSendFetchResponse = 
| FetchResponse<void, 201> 
| ErrorResponse;

export const postServiceInvoicesSendPath = () => `/service-invoices/send`;

export const postServiceInvoicesSend = (headers = new Headers()):
  Promise<PostServiceInvoicesSendFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postServiceInvoicesSendPath()}`, requestData, headers) as Promise<PostServiceInvoicesSendFetchResponse>;
}

export type PostNotificationsJobsStartingTodayFetchResponse = 
| FetchResponse<void, 201> 
| ErrorResponse;

export const postNotificationsJobsStartingTodayPath = () => `/notifications/jobs/starting/today`;

export const postNotificationsJobsStartingToday = (headers = new Headers()):
  Promise<PostNotificationsJobsStartingTodayFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postNotificationsJobsStartingTodayPath()}`, requestData, headers) as Promise<PostNotificationsJobsStartingTodayFetchResponse>;
}

export type PostNotificationsJobsStartingDaysFetchResponse = 
| FetchResponse<void, 201> 
| ErrorResponse;

export const postNotificationsJobsStartingDaysPath = (days: string) => `/notifications/jobs/starting/${days}`;

export const postNotificationsJobsStartingDays = (days: string, headers = new Headers()):
  Promise<PostNotificationsJobsStartingDaysFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postNotificationsJobsStartingDaysPath(days)}`, requestData, headers) as Promise<PostNotificationsJobsStartingDaysFetchResponse>;
}

export type PostNotificationsJobsPendingDaysFetchResponse = 
| FetchResponse<void, 201> 
| ErrorResponse;

export const postNotificationsJobsPendingDaysPath = (days: string) => `/notifications/jobs/pending/${days}`;

export const postNotificationsJobsPendingDays = (days: string, headers = new Headers()):
  Promise<PostNotificationsJobsPendingDaysFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postNotificationsJobsPendingDaysPath(days)}`, requestData, headers) as Promise<PostNotificationsJobsPendingDaysFetchResponse>;
}

export type PostNotificationsRemindersDaysFetchResponse = 
| FetchResponse<void, 201> 
| ErrorResponse;

export const postNotificationsRemindersDaysPath = (days: string) => `/notifications/reminders/${days}`;

export const postNotificationsRemindersDays = (days: string, headers = new Headers()):
  Promise<PostNotificationsRemindersDaysFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postNotificationsRemindersDaysPath(days)}`, requestData, headers) as Promise<PostNotificationsRemindersDaysFetchResponse>;
}

export type PostNotificationsSmsPendingFollowupDayFetchResponse = 
| FetchResponse<void, 201> 
| ErrorResponse;

export const postNotificationsSmsPendingFollowupDayPath = (day: string) => `/notifications/sms/pending-followup/${day}`;

export const postNotificationsSmsPendingFollowupDay = (day: string, headers = new Headers()):
  Promise<PostNotificationsSmsPendingFollowupDayFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postNotificationsSmsPendingFollowupDayPath(day)}`, requestData, headers) as Promise<PostNotificationsSmsPendingFollowupDayFetchResponse>;
}

export type PostNotificationsSmsDateMissingDayFetchResponse = 
| FetchResponse<void, 201> 
| ErrorResponse;

export const postNotificationsSmsDateMissingDayPath = (day: string) => `/notifications/sms/date-missing/${day}`;

export const postNotificationsSmsDateMissingDay = (day: string, headers = new Headers()):
  Promise<PostNotificationsSmsDateMissingDayFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postNotificationsSmsDateMissingDayPath(day)}`, requestData, headers) as Promise<PostNotificationsSmsDateMissingDayFetchResponse>;
}

export type PostNotificationsReviewRequestsFetchResponse = 
| FetchResponse<void, 201> 
| ErrorResponse;

export const postNotificationsReviewRequestsPath = (limit: string) => `/notifications/review-requests`;

export const postNotificationsReviewRequests = (limit: string, headers = new Headers()):
  Promise<PostNotificationsReviewRequestsFetchResponse> => {
    const queryParams = {
      "limit": limit
    };
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postNotificationsReviewRequestsPath(limit)}`, requestData, headers, queryParams) as Promise<PostNotificationsReviewRequestsFetchResponse>;
}

export type PostInitFetchResponse = 
| FetchResponse<void, 201> 
| ErrorResponse;

export const postInitPath = () => `/init`;

export const postInit = (headers = new Headers()):
  Promise<PostInitFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postInitPath()}`, requestData, headers) as Promise<PostInitFetchResponse>;
}

export type GetCompanyCompanyIdBankDetailFetchResponse = 
| FetchResponse<CompanyBankDetailWithRelationsResponseDto[], 200> 
| ErrorResponse;

export const getCompanyCompanyIdBankDetailPath = (companyId: number) => `/company/${companyId}/bank-detail`;

export const getCompanyCompanyIdBankDetail = (companyId: number, headers = new Headers()):
  Promise<GetCompanyCompanyIdBankDetailFetchResponse> => {
    return apiGet(`${getApiUrl()}${getCompanyCompanyIdBankDetailPath(companyId)}`, headers, {}) as Promise<GetCompanyCompanyIdBankDetailFetchResponse>;
}

export type PostCompanyCompanyIdBankDetailFetchResponse = 
| FetchResponse<CompanyBankDetailResponseDto, 200> 
| ErrorResponse;

export const postCompanyCompanyIdBankDetailPath = (companyId: number) => `/company/${companyId}/bank-detail`;

export const postCompanyCompanyIdBankDetail = (requestContract: CompanyBankDetailCreateDto, companyId: number, headers = new Headers()):
  Promise<PostCompanyCompanyIdBankDetailFetchResponse> => {
    const requestData = getApiRequestData<CompanyBankDetailCreateDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postCompanyCompanyIdBankDetailPath(companyId)}`, requestData, headers) as Promise<PostCompanyCompanyIdBankDetailFetchResponse>;
}

export type GetCompanyCompanyIdBankDetailIdFetchResponse = 
| FetchResponse<CompanyBankDetailResponseDto, 200> 
| ErrorResponse;

export const getCompanyCompanyIdBankDetailIdPath = (companyId: number, id: number) => `/company/${companyId}/bank-detail/${id}`;

export const getCompanyCompanyIdBankDetailId = (companyId: number, id: number, headers = new Headers()):
  Promise<GetCompanyCompanyIdBankDetailIdFetchResponse> => {
    return apiGet(`${getApiUrl()}${getCompanyCompanyIdBankDetailIdPath(companyId, id)}`, headers, {}) as Promise<GetCompanyCompanyIdBankDetailIdFetchResponse>;
}

export type PatchCompanyCompanyIdBankDetailIdFetchResponse = 
| FetchResponse<CompanyBankDetailResponseDto, 200> 
| ErrorResponse;

export const patchCompanyCompanyIdBankDetailIdPath = (companyId: number, id: number) => `/company/${companyId}/bank-detail/${id}`;

export const patchCompanyCompanyIdBankDetailId = (requestContract: CompanyBankDetailUpdateDto, companyId: number, id: number, headers = new Headers()):
  Promise<PatchCompanyCompanyIdBankDetailIdFetchResponse> => {
    const requestData = getApiRequestData<CompanyBankDetailUpdateDto>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchCompanyCompanyIdBankDetailIdPath(companyId, id)}`, requestData, headers) as Promise<PatchCompanyCompanyIdBankDetailIdFetchResponse>;
}

export type GetOrdersOrderIdCalculatePriceFetchResponse = 
| FetchResponse<OrderCalculatorResponseDto, 200> 
| ErrorResponse;

export const getOrdersOrderIdCalculatePricePath = (orderId: number) => `/orders/${orderId}/calculate-price`;

export const getOrdersOrderIdCalculatePrice = (orderId: number, headers = new Headers()):
  Promise<GetOrdersOrderIdCalculatePriceFetchResponse> => {
    return apiGet(`${getApiUrl()}${getOrdersOrderIdCalculatePricePath(orderId)}`, headers, {}) as Promise<GetOrdersOrderIdCalculatePriceFetchResponse>;
}

export type GetOrdersOrderIdCallsFetchResponse = 
| FetchResponse<OrderCallResponseDto[], 200> 
| ErrorResponse;

export const getOrdersOrderIdCallsPath = (orderId: number) => `/orders/${orderId}/calls`;

export const getOrdersOrderIdCalls = (orderId: number, headers = new Headers()):
  Promise<GetOrdersOrderIdCallsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getOrdersOrderIdCallsPath(orderId)}`, headers, {}) as Promise<GetOrdersOrderIdCallsFetchResponse>;
}

export type PostOrdersOrderIdCallsFetchResponse = 
| FetchResponse<OrderCallResponseDto, 200> 
| ErrorResponse;

export const postOrdersOrderIdCallsPath = (orderId: number) => `/orders/${orderId}/calls`;

export const postOrdersOrderIdCalls = (requestContract: OrderCallCreateDto, orderId: number, headers = new Headers()):
  Promise<PostOrdersOrderIdCallsFetchResponse> => {
    const requestData = getApiRequestData<OrderCallCreateDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postOrdersOrderIdCallsPath(orderId)}`, requestData, headers) as Promise<PostOrdersOrderIdCallsFetchResponse>;
}

export type PostOrdersPublicTokenPhotosFetchResponse = 
| FetchResponse<OrderPhotoResponseDto[], 201> 
| ErrorResponse;

export const postOrdersPublicTokenPhotosPath = (token: string) => `/orders/public/${token}/photos`;

export const postOrdersPublicTokenPhotos = (requestContract: OrderPhotoUploadDto, token: string, headers = new Headers()):
  Promise<PostOrdersPublicTokenPhotosFetchResponse> => {
    const requestData = getApiRequestData<OrderPhotoUploadDto>(requestContract, true);

    return apiPost(`${getApiUrl()}${postOrdersPublicTokenPhotosPath(token)}`, requestData, headers) as Promise<PostOrdersPublicTokenPhotosFetchResponse>;
}

export type GetOrdersIdPhotosFetchResponse = 
| FetchResponse<OrderPhotoResponseDto[], 200> 
| ErrorResponse;

export const getOrdersIdPhotosPath = (id: number) => `/orders/${id}/photos`;

export const getOrdersIdPhotos = (id: number, headers = new Headers()):
  Promise<GetOrdersIdPhotosFetchResponse> => {
    return apiGet(`${getApiUrl()}${getOrdersIdPhotosPath(id)}`, headers, {}) as Promise<GetOrdersIdPhotosFetchResponse>;
}

export type PostOrdersIdPhotosFetchResponse = 
| FetchResponse<OrderPhotoResponseDto[], 201> 
| ErrorResponse;

export const postOrdersIdPhotosPath = (id: number) => `/orders/${id}/photos`;

export const postOrdersIdPhotos = (requestContract: OrderPhotoUploadDto, id: number, headers = new Headers()):
  Promise<PostOrdersIdPhotosFetchResponse> => {
    const requestData = getApiRequestData<OrderPhotoUploadDto>(requestContract, true);

    return apiPost(`${getApiUrl()}${postOrdersIdPhotosPath(id)}`, requestData, headers) as Promise<PostOrdersIdPhotosFetchResponse>;
}

export type PostOrdersOrderIdEmailsFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const postOrdersOrderIdEmailsPath = (orderId: number) => `/orders/${orderId}/emails`;

export const postOrdersOrderIdEmails = (requestContract: OrderEmailNotificationCreateDto, orderId: number, headers = new Headers()):
  Promise<PostOrdersOrderIdEmailsFetchResponse> => {
    const requestData = getApiRequestData<OrderEmailNotificationCreateDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postOrdersOrderIdEmailsPath(orderId)}`, requestData, headers) as Promise<PostOrdersOrderIdEmailsFetchResponse>;
}

export type GetClaimsFetchResponse = 
| FetchResponse<OrderClaimListResponseDto[], 200> 
| ErrorResponse;

export const getClaimsPath = () => `/claims`;

export const getClaims = (marketId?: number | undefined | null, verticals?: string | undefined | null, headers = new Headers()):
  Promise<GetClaimsFetchResponse> => {
    const queryParams = {
      "marketId": marketId,
      "verticals": verticals
    }
    return apiGet(`${getApiUrl()}${getClaimsPath()}`, headers, queryParams) as Promise<GetClaimsFetchResponse>;
}

export type PostClaimsFetchResponse = 
| FetchResponse<OrderClaimDetailResponseDto, 200> 
| ErrorResponse;

export const postClaimsPath = () => `/claims`;

export const postClaims = (requestContract: OrderClaimCreateDto, headers = new Headers()):
  Promise<PostClaimsFetchResponse> => {
    const requestData = getApiRequestData<OrderClaimCreateDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postClaimsPath()}`, requestData, headers) as Promise<PostClaimsFetchResponse>;
}

export type GetClaimsIdFetchResponse = 
| FetchResponse<OrderClaimDetailResponseDto, 200> 
| ErrorResponse;

export const getClaimsIdPath = (id: number) => `/claims/${id}`;

export const getClaimsId = (id: number, headers = new Headers()):
  Promise<GetClaimsIdFetchResponse> => {
    return apiGet(`${getApiUrl()}${getClaimsIdPath(id)}`, headers, {}) as Promise<GetClaimsIdFetchResponse>;
}

export type PatchClaimsIdFetchResponse = 
| FetchResponse<OrderClaimDetailResponseDto, 200> 
| ErrorResponse;

export const patchClaimsIdPath = (id: number) => `/claims/${id}`;

export const patchClaimsId = (requestContract: OrderClaimUpdateDto, id: number, headers = new Headers()):
  Promise<PatchClaimsIdFetchResponse> => {
    const requestData = getApiRequestData<OrderClaimUpdateDto>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchClaimsIdPath(id)}`, requestData, headers) as Promise<PatchClaimsIdFetchResponse>;
}

export type GetClaimsOrdersOrderIdClaimsFetchResponse = 
| FetchResponse<OrderClaimDetailResponseDto[], 200> 
| ErrorResponse;

export const getClaimsOrdersOrderIdClaimsPath = (orderId: number) => `/claims/orders/${orderId}/claims`;

export const getClaimsOrdersOrderIdClaims = (orderId: number, headers = new Headers()):
  Promise<GetClaimsOrdersOrderIdClaimsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getClaimsOrdersOrderIdClaimsPath(orderId)}`, headers, {}) as Promise<GetClaimsOrdersOrderIdClaimsFetchResponse>;
}

export type GetOrderIdCommentsFetchResponse = 
| FetchResponse<CommentListResponseDto[], 200> 
| ErrorResponse;

export const getOrderIdCommentsPath = (id: number) => `/order/${id}/comments`;

export const getOrderIdComments = (id: number, headers = new Headers()):
  Promise<GetOrderIdCommentsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getOrderIdCommentsPath(id)}`, headers, {}) as Promise<GetOrderIdCommentsFetchResponse>;
}

export type PostOrderIdCommentsFetchResponse = 
| FetchResponse<CommentResponseDto, 200> 
| ErrorResponse;

export const postOrderIdCommentsPath = (id: number) => `/order/${id}/comments`;

export const postOrderIdComments = (requestContract: CommentCreateDto, id: number, headers = new Headers()):
  Promise<PostOrderIdCommentsFetchResponse> => {
    const requestData = getApiRequestData<CommentCreateDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postOrderIdCommentsPath(id)}`, requestData, headers) as Promise<PostOrderIdCommentsFetchResponse>;
}

export type DeleteOrderIdCommentsCommentIdFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const deleteOrderIdCommentsCommentIdPath = (id: number, commentId: number) => `/order/${id}/comments/${commentId}`;

export const deleteOrderIdCommentsCommentId = (id: number, commentId: number, headers = new Headers()):
  Promise<DeleteOrderIdCommentsCommentIdFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteOrderIdCommentsCommentIdPath(id, commentId)}`, headers, {}) as Promise<DeleteOrderIdCommentsCommentIdFetchResponse>;
}

export type PatchOrderIdCommentsCommentIdFetchResponse = 
| FetchResponse<CommentResponseDto, 200> 
| ErrorResponse;

export const patchOrderIdCommentsCommentIdPath = (id: number, commentId: number) => `/order/${id}/comments/${commentId}`;

export const patchOrderIdCommentsCommentId = (requestContract: CommentCreateDto, id: number, commentId: number, headers = new Headers()):
  Promise<PatchOrderIdCommentsCommentIdFetchResponse> => {
    const requestData = getApiRequestData<CommentCreateDto>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchOrderIdCommentsCommentIdPath(id, commentId)}`, requestData, headers) as Promise<PatchOrderIdCommentsCommentIdFetchResponse>;
}

export type GetOrdersOrderIdPartnerAllocationsFetchResponse = 
| FetchResponse<OrderPartnerAllocationResponseDto[], 200> 
| ErrorResponse;

export const getOrdersOrderIdPartnerAllocationsPath = (orderId: number) => `/orders/${orderId}/partner-allocations`;

export const getOrdersOrderIdPartnerAllocations = (orderId: number, headers = new Headers()):
  Promise<GetOrdersOrderIdPartnerAllocationsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getOrdersOrderIdPartnerAllocationsPath(orderId)}`, headers, {}) as Promise<GetOrdersOrderIdPartnerAllocationsFetchResponse>;
}

export type GetPartnersPartnerIdAllocationHistoryFetchResponse = 
| FetchResponse<OrderPartnerAllocationResponseDto[], 200> 
| ErrorResponse;

export const getPartnersPartnerIdAllocationHistoryPath = (partnerId: number) => `/partners/${partnerId}/allocation-history`;

export const getPartnersPartnerIdAllocationHistory = (partnerId: number, headers = new Headers()):
  Promise<GetPartnersPartnerIdAllocationHistoryFetchResponse> => {
    return apiGet(`${getApiUrl()}${getPartnersPartnerIdAllocationHistoryPath(partnerId)}`, headers, {}) as Promise<GetPartnersPartnerIdAllocationHistoryFetchResponse>;
}

export type GetVerticalFetchResponse = 
| FetchResponse<OrderVerticalResponseDto[], 200> 
| ErrorResponse;

export const getVerticalPath = () => `/vertical`;

export const getVertical = (headers = new Headers()):
  Promise<GetVerticalFetchResponse> => {
    return apiGet(`${getApiUrl()}${getVerticalPath()}`, headers, {}) as Promise<GetVerticalFetchResponse>;
}

export type PostVerticalFetchResponse = 
| FetchResponse<OrderVerticalResponseDto, 200> 
| ErrorResponse;

export const postVerticalPath = () => `/vertical`;

export const postVertical = (requestContract: OrderVerticalCreateDto, headers = new Headers()):
  Promise<PostVerticalFetchResponse> => {
    const requestData = getApiRequestData<OrderVerticalCreateDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postVerticalPath()}`, requestData, headers) as Promise<PostVerticalFetchResponse>;
}

export type GetVerticalIdFetchResponse = 
| FetchResponse<OrderVerticalResponseDto, 200> 
| ErrorResponse;

export const getVerticalIdPath = (id: number) => `/vertical/${id}`;

export const getVerticalId = (id: number, headers = new Headers()):
  Promise<GetVerticalIdFetchResponse> => {
    return apiGet(`${getApiUrl()}${getVerticalIdPath(id)}`, headers, {}) as Promise<GetVerticalIdFetchResponse>;
}

export type DeleteVerticalIdFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const deleteVerticalIdPath = (id: number) => `/vertical/${id}`;

export const deleteVerticalId = (id: number, headers = new Headers()):
  Promise<DeleteVerticalIdFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteVerticalIdPath(id)}`, headers, {}) as Promise<DeleteVerticalIdFetchResponse>;
}

export type PutVerticalIdFetchResponse = 
| FetchResponse<OrderVerticalResponseDto, 200> 
| ErrorResponse;

export const putVerticalIdPath = (id: number) => `/vertical/${id}`;

export const putVerticalId = (requestContract: OrderVerticalUpdateDto, id: number, headers = new Headers()):
  Promise<PutVerticalIdFetchResponse> => {
    const requestData = getApiRequestData<OrderVerticalUpdateDto>(requestContract, false);

    return apiPut(`${getApiUrl()}${putVerticalIdPath(id)}`, requestData, headers) as Promise<PutVerticalIdFetchResponse>;
}

export type GetOrderSetupFetchResponse = 
| FetchResponse<OrderSetupListResponseDto[], 200> 
| ErrorResponse;

export const getOrderSetupPath = () => `/order-setup`;

export const getOrderSetup = (marketId: number, verticalId: number, headers = new Headers()):
  Promise<GetOrderSetupFetchResponse> => {
    const queryParams = {
      "marketId": marketId,
      "verticalId": verticalId
    }
    return apiGet(`${getApiUrl()}${getOrderSetupPath()}`, headers, queryParams) as Promise<GetOrderSetupFetchResponse>;
}

export type PostOrderSetupFetchResponse = 
| FetchResponse<OrderSetupDetailResponseDto, 200> 
| ErrorResponse;

export const postOrderSetupPath = () => `/order-setup`;

export const postOrderSetup = (requestContract: OrderSetupCreateDto, headers = new Headers()):
  Promise<PostOrderSetupFetchResponse> => {
    const requestData = getApiRequestData<OrderSetupCreateDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postOrderSetupPath()}`, requestData, headers) as Promise<PostOrderSetupFetchResponse>;
}

export type GetOrderSetupIdFetchResponse = 
| FetchResponse<OrderSetupDetailResponseDto, 200> 
| ErrorResponse;

export const getOrderSetupIdPath = (id: number) => `/order-setup/${id}`;

export const getOrderSetupId = (id: number, headers = new Headers()):
  Promise<GetOrderSetupIdFetchResponse> => {
    return apiGet(`${getApiUrl()}${getOrderSetupIdPath(id)}`, headers, {}) as Promise<GetOrderSetupIdFetchResponse>;
}

export type DeleteOrderSetupIdFetchResponse = 
| FetchResponse<boolean, 200> 
| ErrorResponse;

export const deleteOrderSetupIdPath = (id: number) => `/order-setup/${id}`;

export const deleteOrderSetupId = (id: number, headers = new Headers()):
  Promise<DeleteOrderSetupIdFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteOrderSetupIdPath(id)}`, headers, {}) as Promise<DeleteOrderSetupIdFetchResponse>;
}

export type PutOrderSetupIdFetchResponse = 
| FetchResponse<OrderSetupDetailResponseDto, 200> 
| ErrorResponse;

export const putOrderSetupIdPath = (id: number) => `/order-setup/${id}`;

export const putOrderSetupId = (requestContract: OrderSetupUpdateDto, id: number, headers = new Headers()):
  Promise<PutOrderSetupIdFetchResponse> => {
    const requestData = getApiRequestData<OrderSetupUpdateDto>(requestContract, false);

    return apiPut(`${getApiUrl()}${putOrderSetupIdPath(id)}`, requestData, headers) as Promise<PutOrderSetupIdFetchResponse>;
}

export type GetOrdersOrderIdPaymentsFetchResponse = 
| FetchResponse<OrderPaymentResponseDto[], 200> 
| ErrorResponse;

export const getOrdersOrderIdPaymentsPath = (orderId: number) => `/orders/${orderId}/payments`;

export const getOrdersOrderIdPayments = (orderId: number, headers = new Headers()):
  Promise<GetOrdersOrderIdPaymentsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getOrdersOrderIdPaymentsPath(orderId)}`, headers, {}) as Promise<GetOrdersOrderIdPaymentsFetchResponse>;
}

export type PostOrdersOrderIdPaymentsFetchResponse = 
| FetchResponse<OrderPaymentResponseDto, 200> 
| ErrorResponse;

export const postOrdersOrderIdPaymentsPath = (orderId: number) => `/orders/${orderId}/payments`;

export const postOrdersOrderIdPayments = (requestContract: OrderPaymentCreateDto, orderId: number, headers = new Headers()):
  Promise<PostOrdersOrderIdPaymentsFetchResponse> => {
    const requestData = getApiRequestData<OrderPaymentCreateDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postOrdersOrderIdPaymentsPath(orderId)}`, requestData, headers) as Promise<PostOrdersOrderIdPaymentsFetchResponse>;
}

export type DeleteOrdersOrderIdPaymentsPaymentIdFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const deleteOrdersOrderIdPaymentsPaymentIdPath = (orderId: number, paymentId: number) => `/orders/${orderId}/payments/${paymentId}`;

export const deleteOrdersOrderIdPaymentsPaymentId = (orderId: number, paymentId: number, headers = new Headers()):
  Promise<DeleteOrdersOrderIdPaymentsPaymentIdFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteOrdersOrderIdPaymentsPaymentIdPath(orderId, paymentId)}`, headers, {}) as Promise<DeleteOrdersOrderIdPaymentsPaymentIdFetchResponse>;
}

export type PatchOrdersOrderIdPaymentsPaymentIdFetchResponse = 
| FetchResponse<OrderPaymentResponseDto, 200> 
| ErrorResponse;

export const patchOrdersOrderIdPaymentsPaymentIdPath = (orderId: number, paymentId: number) => `/orders/${orderId}/payments/${paymentId}`;

export const patchOrdersOrderIdPaymentsPaymentId = (requestContract: OrderPaymentCreateDto, orderId: number, paymentId: number, headers = new Headers()):
  Promise<PatchOrdersOrderIdPaymentsPaymentIdFetchResponse> => {
    const requestData = getApiRequestData<OrderPaymentCreateDto>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchOrdersOrderIdPaymentsPaymentIdPath(orderId, paymentId)}`, requestData, headers) as Promise<PatchOrdersOrderIdPaymentsPaymentIdFetchResponse>;
}

export type PostOrdersOrderIdPaymentsExpressPayoutFetchResponse = 
| FetchResponse<OrderPaymentResponseDto, 200> 
| ErrorResponse;

export const postOrdersOrderIdPaymentsExpressPayoutPath = (orderId: number) => `/orders/${orderId}/payments/express-payout`;

export const postOrdersOrderIdPaymentsExpressPayout = (orderId: number, headers = new Headers()):
  Promise<PostOrdersOrderIdPaymentsExpressPayoutFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postOrdersOrderIdPaymentsExpressPayoutPath(orderId)}`, requestData, headers) as Promise<PostOrdersOrderIdPaymentsExpressPayoutFetchResponse>;
}

export type PostOrdersOrderIdCreateCheckoutSessionFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const postOrdersOrderIdCreateCheckoutSessionPath = (orderId: number) => `/orders/${orderId}/create-checkout-session`;

export const postOrdersOrderIdCreateCheckoutSession = (orderId: number, headers = new Headers()):
  Promise<PostOrdersOrderIdCreateCheckoutSessionFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postOrdersOrderIdCreateCheckoutSessionPath(orderId)}`, requestData, headers) as Promise<PostOrdersOrderIdCreateCheckoutSessionFetchResponse>;
}

export type PostStripeWebhookFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const postStripeWebhookPath = () => `/stripe/webhook`;

export const postStripeWebhook = (headers = new Headers()):
  Promise<PostStripeWebhookFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postStripeWebhookPath()}`, requestData, headers) as Promise<PostStripeWebhookFetchResponse>;
}

export type GetOrdersOrderIdPaymentDetailFetchResponse = 
| FetchResponse<OrderPaymentDetailResponseDto, 200> 
| ErrorResponse;

export const getOrdersOrderIdPaymentDetailPath = (orderId: number) => `/orders/${orderId}/payment-detail`;

export const getOrdersOrderIdPaymentDetail = (orderId: number, headers = new Headers()):
  Promise<GetOrdersOrderIdPaymentDetailFetchResponse> => {
    return apiGet(`${getApiUrl()}${getOrdersOrderIdPaymentDetailPath(orderId)}`, headers, {}) as Promise<GetOrdersOrderIdPaymentDetailFetchResponse>;
}

export type GetOrdersOrderIdFeeFetchResponse = 
| FetchResponse<OrderFeeResponseDto, 200> 
| ErrorResponse;

export const getOrdersOrderIdFeePath = (orderId: number) => `/orders/${orderId}/fee`;

export const getOrdersOrderIdFee = (orderId: number, headers = new Headers()):
  Promise<GetOrdersOrderIdFeeFetchResponse> => {
    return apiGet(`${getApiUrl()}${getOrdersOrderIdFeePath(orderId)}`, headers, {}) as Promise<GetOrdersOrderIdFeeFetchResponse>;
}

export type PatchOrdersOrderIdFeeFeeIdFetchResponse = 
| FetchResponse<OrderFeeResponseDto, 200> 
| ErrorResponse;

export const patchOrdersOrderIdFeeFeeIdPath = (orderId: number, feeId: number) => `/orders/${orderId}/fee/${feeId}`;

export const patchOrdersOrderIdFeeFeeId = (requestContract: OrderFeeUpdateDto, orderId: number, feeId: number, headers = new Headers()):
  Promise<PatchOrdersOrderIdFeeFeeIdFetchResponse> => {
    const requestData = getApiRequestData<OrderFeeUpdateDto>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchOrdersOrderIdFeeFeeIdPath(orderId, feeId)}`, requestData, headers) as Promise<PatchOrdersOrderIdFeeFeeIdFetchResponse>;
}

export type PostOrdersOrderIdFeeUpdateFeeManuallyFetchResponse = 
| FetchResponse<void, 201> 
| ErrorResponse;

export const postOrdersOrderIdFeeUpdateFeeManuallyPath = (orderId: number) => `/orders/${orderId}/fee/update-fee-manually`;

export const postOrdersOrderIdFeeUpdateFeeManually = (orderId: number, headers = new Headers()):
  Promise<PostOrdersOrderIdFeeUpdateFeeManuallyFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postOrdersOrderIdFeeUpdateFeeManuallyPath(orderId)}`, requestData, headers) as Promise<PostOrdersOrderIdFeeUpdateFeeManuallyFetchResponse>;
}

export type GetOrdersOrderIdChargesFetchResponse = 
| FetchResponse<OrderChargeResponseDto[], 200> 
| ErrorResponse;

export const getOrdersOrderIdChargesPath = (orderId: number) => `/orders/${orderId}/charges`;

export const getOrdersOrderIdCharges = (orderId: number, headers = new Headers()):
  Promise<GetOrdersOrderIdChargesFetchResponse> => {
    return apiGet(`${getApiUrl()}${getOrdersOrderIdChargesPath(orderId)}`, headers, {}) as Promise<GetOrdersOrderIdChargesFetchResponse>;
}

export type PostOrdersOrderIdChargesFetchResponse = 
| FetchResponse<OrderChargeResponseDto, 200> 
| ErrorResponse;

export const postOrdersOrderIdChargesPath = (orderId: number) => `/orders/${orderId}/charges`;

export const postOrdersOrderIdCharges = (requestContract: OrderChargeCreateDto, orderId: number, headers = new Headers()):
  Promise<PostOrdersOrderIdChargesFetchResponse> => {
    const requestData = getApiRequestData<OrderChargeCreateDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postOrdersOrderIdChargesPath(orderId)}`, requestData, headers) as Promise<PostOrdersOrderIdChargesFetchResponse>;
}

export type DeleteOrdersOrderIdChargesChargeIdFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const deleteOrdersOrderIdChargesChargeIdPath = (orderId: number, chargeId: number) => `/orders/${orderId}/charges/${chargeId}`;

export const deleteOrdersOrderIdChargesChargeId = (orderId: number, chargeId: number, headers = new Headers()):
  Promise<DeleteOrdersOrderIdChargesChargeIdFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteOrdersOrderIdChargesChargeIdPath(orderId, chargeId)}`, headers, {}) as Promise<DeleteOrdersOrderIdChargesChargeIdFetchResponse>;
}

export type PatchOrdersOrderIdChargesChargeIdFetchResponse = 
| FetchResponse<OrderChargeResponseDto, 200> 
| ErrorResponse;

export const patchOrdersOrderIdChargesChargeIdPath = (orderId: number, chargeId: number) => `/orders/${orderId}/charges/${chargeId}`;

export const patchOrdersOrderIdChargesChargeId = (requestContract: OrderChargeUpdateDto, orderId: number, chargeId: number, headers = new Headers()):
  Promise<PatchOrdersOrderIdChargesChargeIdFetchResponse> => {
    const requestData = getApiRequestData<OrderChargeUpdateDto>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchOrdersOrderIdChargesChargeIdPath(orderId, chargeId)}`, requestData, headers) as Promise<PatchOrdersOrderIdChargesChargeIdFetchResponse>;
}

export type GetOrdersOrderIdChargesSumFetchResponse = 
| FetchResponse<number, 200> 
| ErrorResponse;

export const getOrdersOrderIdChargesSumPath = (orderId: number) => `/orders/${orderId}/charges/sum`;

export const getOrdersOrderIdChargesSum = (orderId: number, headers = new Headers()):
  Promise<GetOrdersOrderIdChargesSumFetchResponse> => {
    return apiGet(`${getApiUrl()}${getOrdersOrderIdChargesSumPath(orderId)}`, headers, {}) as Promise<GetOrdersOrderIdChargesSumFetchResponse>;
}

export type PostExaminationsFetchResponse = 
| FetchResponse<OrderExaminationResponseDto, 200> 
| ErrorResponse;

export const postExaminationsPath = () => `/examinations`;

export const postExaminations = (requestContract: OrderExaminationCreateDto, headers = new Headers()):
  Promise<PostExaminationsFetchResponse> => {
    const requestData = getApiRequestData<OrderExaminationCreateDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postExaminationsPath()}`, requestData, headers) as Promise<PostExaminationsFetchResponse>;
}

export type DeleteExaminationsIdFetchResponse = 
| FetchResponse<void, 204> 
| ErrorResponse;

export const deleteExaminationsIdPath = (id: number) => `/examinations/${id}`;

export const deleteExaminationsId = (id: number, headers = new Headers()):
  Promise<DeleteExaminationsIdFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteExaminationsIdPath(id)}`, headers, {}) as Promise<DeleteExaminationsIdFetchResponse>;
}

export type PatchExaminationsIdFetchResponse = 
| FetchResponse<OrderExaminationResponseDto, 200> 
| ErrorResponse;

export const patchExaminationsIdPath = (id: number) => `/examinations/${id}`;

export const patchExaminationsId = (requestContract: OrderExaminationUpdateDto, id: number, headers = new Headers()):
  Promise<PatchExaminationsIdFetchResponse> => {
    const requestData = getApiRequestData<OrderExaminationUpdateDto>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchExaminationsIdPath(id)}`, requestData, headers) as Promise<PatchExaminationsIdFetchResponse>;
}

export type GetExaminationsListFetchResponse = 
| FetchResponse<OrderExaminationResponseDto[], 200> 
| ErrorResponse;

export const getExaminationsListPath = () => `/examinations/list`;

export const getExaminationsList = (headers = new Headers()):
  Promise<GetExaminationsListFetchResponse> => {
    return apiGet(`${getApiUrl()}${getExaminationsListPath()}`, headers, {}) as Promise<GetExaminationsListFetchResponse>;
}

export type GetExaminationsOrdersOrderIdFetchResponse = 
| FetchResponse<OrderExaminationResponseDto, 200> 
| ErrorResponse;

export const getExaminationsOrdersOrderIdPath = (orderId: number) => `/examinations/orders/${orderId}`;

export const getExaminationsOrdersOrderId = (orderId: number, headers = new Headers()):
  Promise<GetExaminationsOrdersOrderIdFetchResponse> => {
    return apiGet(`${getApiUrl()}${getExaminationsOrdersOrderIdPath(orderId)}`, headers, {}) as Promise<GetExaminationsOrdersOrderIdFetchResponse>;
}

export type PutExaminationsOrdersOrderIdResultFetchResponse = 
| FetchResponse<OrderExaminationResponseDto, 200> 
| ErrorResponse;

export const putExaminationsOrdersOrderIdResultPath = (orderId: number) => `/examinations/orders/${orderId}/result`;

export const putExaminationsOrdersOrderIdResult = (requestContract: OrderExaminationResultDto, orderId: number, headers = new Headers()):
  Promise<PutExaminationsOrdersOrderIdResultFetchResponse> => {
    const requestData = getApiRequestData<OrderExaminationResultDto>(requestContract, false);

    return apiPut(`${getApiUrl()}${putExaminationsOrdersOrderIdResultPath(orderId)}`, requestData, headers) as Promise<PutExaminationsOrdersOrderIdResultFetchResponse>;
}

export type GetOrdersReviewOrderOrderIdFetchResponse = 
| FetchResponse<PartnerReviewResponseDto[], 200> 
| ErrorResponse;

export const getOrdersReviewOrderOrderIdPath = (orderId: number) => `/orders/review/order/${orderId}`;

export const getOrdersReviewOrderOrderId = (orderId: number, headers = new Headers()):
  Promise<GetOrdersReviewOrderOrderIdFetchResponse> => {
    return apiGet(`${getApiUrl()}${getOrdersReviewOrderOrderIdPath(orderId)}`, headers, {}) as Promise<GetOrdersReviewOrderOrderIdFetchResponse>;
}

export type GetOrdersReviewPartnerPartnerIdFetchResponse = 
| FetchResponse<PartnerReviewResponseDto[], 200> 
| ErrorResponse;

export const getOrdersReviewPartnerPartnerIdPath = (partnerId: number) => `/orders/review/partner/${partnerId}`;

export const getOrdersReviewPartnerPartnerId = (partnerId: number, headers = new Headers()):
  Promise<GetOrdersReviewPartnerPartnerIdFetchResponse> => {
    return apiGet(`${getApiUrl()}${getOrdersReviewPartnerPartnerIdPath(partnerId)}`, headers, {}) as Promise<GetOrdersReviewPartnerPartnerIdFetchResponse>;
}

export type PostOrdersReviewOrderIdFetchResponse = 
| FetchResponse<PartnerReviewResponseDto, 200> 
| ErrorResponse;

export const postOrdersReviewOrderIdPath = (orderId: number) => `/orders/review/${orderId}`;

export const postOrdersReviewOrderId = (requestContract: PartnerReviewCreateDto, orderId: number, headers = new Headers()):
  Promise<PostOrdersReviewOrderIdFetchResponse> => {
    const requestData = getApiRequestData<PartnerReviewCreateDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postOrdersReviewOrderIdPath(orderId)}`, requestData, headers) as Promise<PostOrdersReviewOrderIdFetchResponse>;
}

export type DeleteOrdersReviewReviewIdFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const deleteOrdersReviewReviewIdPath = (reviewId: number) => `/orders/review/${reviewId}`;

export const deleteOrdersReviewReviewId = (reviewId: number, headers = new Headers()):
  Promise<DeleteOrdersReviewReviewIdFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteOrdersReviewReviewIdPath(reviewId)}`, headers, {}) as Promise<DeleteOrdersReviewReviewIdFetchResponse>;
}

export type PatchOrdersReviewReviewIdFetchResponse = 
| FetchResponse<PartnerReviewResponseDto, 200> 
| ErrorResponse;

export const patchOrdersReviewReviewIdPath = (reviewId: number) => `/orders/review/${reviewId}`;

export const patchOrdersReviewReviewId = (requestContract: PartnerReviewUpdateDto, reviewId: number, headers = new Headers()):
  Promise<PatchOrdersReviewReviewIdFetchResponse> => {
    const requestData = getApiRequestData<PartnerReviewUpdateDto>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchOrdersReviewReviewIdPath(reviewId)}`, requestData, headers) as Promise<PatchOrdersReviewReviewIdFetchResponse>;
}

export type GetOrdersOrderIdTimelineFetchResponse = 
| FetchResponse<OrderTimelineResponseDto[], 200> 
| ErrorResponse;

export const getOrdersOrderIdTimelinePath = (orderId: number) => `/orders/${orderId}/timeline`;

export const getOrdersOrderIdTimeline = (orderId: number, headers = new Headers()):
  Promise<GetOrdersOrderIdTimelineFetchResponse> => {
    return apiGet(`${getApiUrl()}${getOrdersOrderIdTimelinePath(orderId)}`, headers, {}) as Promise<GetOrdersOrderIdTimelineFetchResponse>;
}

export type GetOrdersOrderIdProtocolsFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const getOrdersOrderIdProtocolsPath = (orderId: number) => `/orders/${orderId}/protocols`;

export const getOrdersOrderIdProtocols = (orderId: number, headers = new Headers()):
  Promise<GetOrdersOrderIdProtocolsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getOrdersOrderIdProtocolsPath(orderId)}`, headers, {}) as Promise<GetOrdersOrderIdProtocolsFetchResponse>;
}

export type GetOrdersOrderIdProtocolsDocumentFetchResponse = 
| FetchResponse<ProtocolDocumentResponseDto, 200> 
| ErrorResponse;

export const getOrdersOrderIdProtocolsDocumentPath = (orderId: number) => `/orders/${orderId}/protocols/document`;

export const getOrdersOrderIdProtocolsDocument = (orderId: number, headers = new Headers()):
  Promise<GetOrdersOrderIdProtocolsDocumentFetchResponse> => {
    return apiGet(`${getApiUrl()}${getOrdersOrderIdProtocolsDocumentPath(orderId)}`, headers, {}) as Promise<GetOrdersOrderIdProtocolsDocumentFetchResponse>;
}

export type GetOrdersOrderIdProtocolsPdfFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const getOrdersOrderIdProtocolsPdfPath = (orderId: number) => `/orders/${orderId}/protocols/pdf`;

export const getOrdersOrderIdProtocolsPdf = (orderId: number, headers = new Headers()):
  Promise<GetOrdersOrderIdProtocolsPdfFetchResponse> => {
    return apiGet(`${getApiUrl()}${getOrdersOrderIdProtocolsPdfPath(orderId)}`, headers, {}) as Promise<GetOrdersOrderIdProtocolsPdfFetchResponse>;
}

export type GetProtocolsFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const getProtocolsPath = () => `/protocols`;

export const getProtocols = (page?: number, limit?: number, type?: string, status?: string, headers = new Headers()):
  Promise<GetProtocolsFetchResponse> => {
    const queryParams = {
      "page": page,
      "limit": limit,
      "type": type,
      "status": status
    }
    return apiGet(`${getApiUrl()}${getProtocolsPath()}`, headers, queryParams) as Promise<GetProtocolsFetchResponse>;
}

export type GetPartnersPartnerIdOrdersOrderIdProtocolsFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const getPartnersPartnerIdOrdersOrderIdProtocolsPath = (orderId: number, partnerId: number) => `/partners/${partnerId}/orders/${orderId}/protocols`;

export const getPartnersPartnerIdOrdersOrderIdProtocols = (orderId: number, partnerId: number, headers = new Headers()):
  Promise<GetPartnersPartnerIdOrdersOrderIdProtocolsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getPartnersPartnerIdOrdersOrderIdProtocolsPath(orderId, partnerId)}`, headers, {}) as Promise<GetPartnersPartnerIdOrdersOrderIdProtocolsFetchResponse>;
}

export type PutPartnersPartnerIdOrdersOrderIdProtocolsTypeFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const putPartnersPartnerIdOrdersOrderIdProtocolsTypePath = (orderId: number, partnerId: number, type: string) => `/partners/${partnerId}/orders/${orderId}/protocols/${type}`;

export const putPartnersPartnerIdOrdersOrderIdProtocolsType = (requestContract: SaveProtocolDto, orderId: number, partnerId: number, type: string, headers = new Headers()):
  Promise<PutPartnersPartnerIdOrdersOrderIdProtocolsTypeFetchResponse> => {
    const requestData = getApiRequestData<SaveProtocolDto>(requestContract, false);

    return apiPut(`${getApiUrl()}${putPartnersPartnerIdOrdersOrderIdProtocolsTypePath(orderId, partnerId, type)}`, requestData, headers) as Promise<PutPartnersPartnerIdOrdersOrderIdProtocolsTypeFetchResponse>;
}

export type PostPartnersPartnerIdOrdersOrderIdProtocolsTypeSendFetchResponse = 
| FetchResponse<void, 201> 
| ErrorResponse;

export const postPartnersPartnerIdOrdersOrderIdProtocolsTypeSendPath = (orderId: number, partnerId: number, type: string) => `/partners/${partnerId}/orders/${orderId}/protocols/${type}/send`;

export const postPartnersPartnerIdOrdersOrderIdProtocolsTypeSend = (orderId: number, partnerId: number, type: string, headers = new Headers()):
  Promise<PostPartnersPartnerIdOrdersOrderIdProtocolsTypeSendFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postPartnersPartnerIdOrdersOrderIdProtocolsTypeSendPath(orderId, partnerId, type)}`, requestData, headers) as Promise<PostPartnersPartnerIdOrdersOrderIdProtocolsTypeSendFetchResponse>;
}

export type PostProtocolsAutoApproveFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const postProtocolsAutoApprovePath = () => `/protocols/auto-approve`;

export const postProtocolsAutoApprove = (headers = new Headers()):
  Promise<PostProtocolsAutoApproveFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postProtocolsAutoApprovePath()}`, requestData, headers) as Promise<PostProtocolsAutoApproveFetchResponse>;
}

export type GetCustomerProtocolsTokenFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const getCustomerProtocolsTokenPath = (token: string) => `/customer-protocols/${token}`;

export const getCustomerProtocolsToken = (token: string, headers = new Headers()):
  Promise<GetCustomerProtocolsTokenFetchResponse> => {
    return apiGet(`${getApiUrl()}${getCustomerProtocolsTokenPath(token)}`, headers, {}) as Promise<GetCustomerProtocolsTokenFetchResponse>;
}

export type PostCustomerProtocolsTokenDecisionFetchResponse = 
| FetchResponse<void, 201> 
| ErrorResponse;

export const postCustomerProtocolsTokenDecisionPath = (token: string) => `/customer-protocols/${token}/decision`;

export const postCustomerProtocolsTokenDecision = (requestContract: CustomerDecisionDto, token: string, headers = new Headers()):
  Promise<PostCustomerProtocolsTokenDecisionFetchResponse> => {
    const requestData = getApiRequestData<CustomerDecisionDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postCustomerProtocolsTokenDecisionPath(token)}`, requestData, headers) as Promise<PostCustomerProtocolsTokenDecisionFetchResponse>;
}

export type GetPartnersPartnerIdAvailabilityFilterFetchResponse = 
| FetchResponse<PartnerAvailabilityResponseDto[], 200> 
| ErrorResponse;

export const getPartnersPartnerIdAvailabilityFilterPath = (partnerId: number) => `/partners/${partnerId}/availability/filter`;

export const getPartnersPartnerIdAvailabilityFilter = (partnerId: number, dateFrom?: string, dateTo?: string, headers = new Headers()):
  Promise<GetPartnersPartnerIdAvailabilityFilterFetchResponse> => {
    const queryParams = {
      "dateFrom": dateFrom,
      "dateTo": dateTo
    }
    return apiGet(`${getApiUrl()}${getPartnersPartnerIdAvailabilityFilterPath(partnerId)}`, headers, queryParams) as Promise<GetPartnersPartnerIdAvailabilityFilterFetchResponse>;
}

export type GetPartnersPartnerIdAvailabilityFetchResponse = 
| FetchResponse<PartnerAvailabilityResponseDto[], 200> 
| ErrorResponse;

export const getPartnersPartnerIdAvailabilityPath = (partnerId: number) => `/partners/${partnerId}/availability`;

export const getPartnersPartnerIdAvailability = (partnerId: number, dateFrom?: string, dateTo?: string, headers = new Headers()):
  Promise<GetPartnersPartnerIdAvailabilityFetchResponse> => {
    const queryParams = {
      "dateFrom": dateFrom,
      "dateTo": dateTo
    }
    return apiGet(`${getApiUrl()}${getPartnersPartnerIdAvailabilityPath(partnerId)}`, headers, queryParams) as Promise<GetPartnersPartnerIdAvailabilityFetchResponse>;
}

export type PutPartnersPartnerIdAvailabilityFetchResponse = 
| FetchResponse<PartnerAvailabilityResponseDto, 200> 
| ErrorResponse;

export const putPartnersPartnerIdAvailabilityPath = (partnerId: number) => `/partners/${partnerId}/availability`;

export const putPartnersPartnerIdAvailability = (requestContract: PartnerAvailabilityCreateDto, partnerId: number, headers = new Headers()):
  Promise<PutPartnersPartnerIdAvailabilityFetchResponse> => {
    const requestData = getApiRequestData<PartnerAvailabilityCreateDto>(requestContract, false);

    return apiPut(`${getApiUrl()}${putPartnersPartnerIdAvailabilityPath(partnerId)}`, requestData, headers) as Promise<PutPartnersPartnerIdAvailabilityFetchResponse>;
}

export type PatchPartnersPartnerIdAvailabilityFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const patchPartnersPartnerIdAvailabilityPath = (partnerId: number) => `/partners/${partnerId}/availability`;

export const patchPartnersPartnerIdAvailability = (requestContract: PartnerAvailabilityBulkUpdateDto, partnerId: number, headers = new Headers()):
  Promise<PatchPartnersPartnerIdAvailabilityFetchResponse> => {
    const requestData = getApiRequestData<PartnerAvailabilityBulkUpdateDto>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchPartnersPartnerIdAvailabilityPath(partnerId)}`, requestData, headers) as Promise<PatchPartnersPartnerIdAvailabilityFetchResponse>;
}

export type PostPartnersCalendarFetchResponse = 
| FetchResponse<PartnerCalendarResponseDto, 200> 
| ErrorResponse;

export const postPartnersCalendarPath = () => `/partners/calendar`;

export const postPartnersCalendar = (requestContract: PartnerCalendarRequestDto, headers = new Headers()):
  Promise<PostPartnersCalendarFetchResponse> => {
    const requestData = getApiRequestData<PartnerCalendarRequestDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPartnersCalendarPath()}`, requestData, headers) as Promise<PostPartnersCalendarFetchResponse>;
}

export type PutPartnersCalendarAvailabilityBulkFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const putPartnersCalendarAvailabilityBulkPath = () => `/partners/calendar/availability/bulk`;

export const putPartnersCalendarAvailabilityBulk = (requestContract: PartnerAvailabilityBulkUpdateDto, headers = new Headers()):
  Promise<PutPartnersCalendarAvailabilityBulkFetchResponse> => {
    const requestData = getApiRequestData<PartnerAvailabilityBulkUpdateDto>(requestContract, false);

    return apiPut(`${getApiUrl()}${putPartnersCalendarAvailabilityBulkPath()}`, requestData, headers) as Promise<PutPartnersCalendarAvailabilityBulkFetchResponse>;
}

export type PostPartnersCalendarAvailablePartnersFetchResponse = 
| FetchResponse<FindAvailablePartnersResponseDto, 200> 
| ErrorResponse;

export const postPartnersCalendarAvailablePartnersPath = () => `/partners/calendar/available-partners`;

export const postPartnersCalendarAvailablePartners = (requestContract: FindAvailablePartnersRequestDto, headers = new Headers()):
  Promise<PostPartnersCalendarAvailablePartnersFetchResponse> => {
    const requestData = getApiRequestData<FindAvailablePartnersRequestDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPartnersCalendarAvailablePartnersPath()}`, requestData, headers) as Promise<PostPartnersCalendarAvailablePartnersFetchResponse>;
}

export type GetPartnersCalendarAvailableDatesFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const getPartnersCalendarAvailableDatesPath = () => `/partners/calendar/available-dates`;

export const getPartnersCalendarAvailableDates = (orderId: number, dateFrom: string, headers = new Headers()):
  Promise<GetPartnersCalendarAvailableDatesFetchResponse> => {
    const queryParams = {
      "orderId": orderId,
      "dateFrom": dateFrom
    }
    return apiGet(`${getApiUrl()}${getPartnersCalendarAvailableDatesPath()}`, headers, queryParams) as Promise<GetPartnersCalendarAvailableDatesFetchResponse>;
}

export type PostPartnersCalendarOfferFetchResponse = 
| FetchResponse<PartnerOfferResponseDto[], 200> 
| ErrorResponse;

export const postPartnersCalendarOfferPath = () => `/partners/calendar/offer`;

export const postPartnersCalendarOffer = (requestContract: CreateOfferRequestDto, headers = new Headers()):
  Promise<PostPartnersCalendarOfferFetchResponse> => {
    const requestData = getApiRequestData<CreateOfferRequestDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPartnersCalendarOfferPath()}`, requestData, headers) as Promise<PostPartnersCalendarOfferFetchResponse>;
}

export type PostPartnersCalendarOrdersOrderIdAllocationFlowFetchResponse = 
| FetchResponse<ManualAllocationFlowResponseDto, 200> 
| ErrorResponse;

export const postPartnersCalendarOrdersOrderIdAllocationFlowPath = (orderId: number) => `/partners/calendar/orders/${orderId}/allocation-flow`;

export const postPartnersCalendarOrdersOrderIdAllocationFlow = (requestContract: TriggerAllocationFlowRequestDto, orderId: number, headers = new Headers()):
  Promise<PostPartnersCalendarOrdersOrderIdAllocationFlowFetchResponse> => {
    const requestData = getApiRequestData<TriggerAllocationFlowRequestDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPartnersCalendarOrdersOrderIdAllocationFlowPath(orderId)}`, requestData, headers) as Promise<PostPartnersCalendarOrdersOrderIdAllocationFlowFetchResponse>;
}

export type PostPartnersCalendarOrdersOrderIdRejectAssignmentFetchResponse = 
| FetchResponse<RejectOrderAssignmentResponseDto, 200> 
| ErrorResponse;

export const postPartnersCalendarOrdersOrderIdRejectAssignmentPath = (orderId: number) => `/partners/calendar/orders/${orderId}/reject-assignment`;

export const postPartnersCalendarOrdersOrderIdRejectAssignment = (requestContract: RejectOrderAssignmentRequestDto, orderId: number, headers = new Headers()):
  Promise<PostPartnersCalendarOrdersOrderIdRejectAssignmentFetchResponse> => {
    const requestData = getApiRequestData<RejectOrderAssignmentRequestDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPartnersCalendarOrdersOrderIdRejectAssignmentPath(orderId)}`, requestData, headers) as Promise<PostPartnersCalendarOrdersOrderIdRejectAssignmentFetchResponse>;
}

export type PostPartnersCalendarOfferOfferIdRespondFetchResponse = 
| FetchResponse<void, 204> 
| ErrorResponse;

export const postPartnersCalendarOfferOfferIdRespondPath = (offerId: number) => `/partners/calendar/offer/${offerId}/respond`;

export const postPartnersCalendarOfferOfferIdRespond = (offerId: number, headers = new Headers()):
  Promise<PostPartnersCalendarOfferOfferIdRespondFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postPartnersCalendarOfferOfferIdRespondPath(offerId)}`, requestData, headers) as Promise<PostPartnersCalendarOfferOfferIdRespondFetchResponse>;
}

export type GetPartnersCalendarOffersPendingFetchResponse = 
| FetchResponse<PartnerOfferResponseDto[], 200> 
| ErrorResponse;

export const getPartnersCalendarOffersPendingPath = () => `/partners/calendar/offers/pending`;

export const getPartnersCalendarOffersPending = (partnerId: number, headers = new Headers()):
  Promise<GetPartnersCalendarOffersPendingFetchResponse> => {
    const queryParams = {
      "partnerId": partnerId
    }
    return apiGet(`${getApiUrl()}${getPartnersCalendarOffersPendingPath()}`, headers, queryParams) as Promise<GetPartnersCalendarOffersPendingFetchResponse>;
}

export type PostPartnersCalendarDelayedAllocationsFetchResponse = 
| FetchResponse<void, 200> 
| ErrorResponse;

export const postPartnersCalendarDelayedAllocationsPath = () => `/partners/calendar/delayed-allocations`;

export const postPartnersCalendarDelayedAllocations = (headers = new Headers()):
  Promise<PostPartnersCalendarDelayedAllocationsFetchResponse> => {
    const requestData = getApiRequestData<object>(undefined, false);

    return apiPost(`${getApiUrl()}${postPartnersCalendarDelayedAllocationsPath()}`, requestData, headers) as Promise<PostPartnersCalendarDelayedAllocationsFetchResponse>;
}

export type GetOrdersOrderIdFieldFetchResponse = 
| FetchResponse<OrderFieldLookupResponseDto, 200> 
| ErrorResponse;

export const getOrdersOrderIdFieldPath = (orderId: number) => `/orders/${orderId}/field`;

export const getOrdersOrderIdField = (orderId: number, fieldKey: string, headers = new Headers()):
  Promise<GetOrdersOrderIdFieldFetchResponse> => {
    const queryParams = {
      "fieldKey": fieldKey
    }
    return apiGet(`${getApiUrl()}${getOrdersOrderIdFieldPath(orderId)}`, headers, queryParams) as Promise<GetOrdersOrderIdFieldFetchResponse>;
}

export type GetOrdersFieldMappingsFetchResponse = 
| FetchResponse<OrderFieldMappingsResponseDto, 200> 
| ErrorResponse;

export const getOrdersFieldMappingsPath = () => `/orders/field-mappings`;

export const getOrdersFieldMappings = (headers = new Headers()):
  Promise<GetOrdersFieldMappingsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getOrdersFieldMappingsPath()}`, headers, {}) as Promise<GetOrdersFieldMappingsFetchResponse>;
}

export type GetMarketsMarketIdRegionsFetchResponse = 
| FetchResponse<MarketRegionResponseDto[], 200> 
| ErrorResponse;

export const getMarketsMarketIdRegionsPath = (marketId: number) => `/markets/${marketId}/regions`;

export const getMarketsMarketIdRegions = (marketId: number, isDeleted?: boolean, name?: string, timezone?: string, headers = new Headers()):
  Promise<GetMarketsMarketIdRegionsFetchResponse> => {
    const queryParams = {
      "isDeleted": isDeleted,
      "name": name,
      "timezone": timezone
    }
    return apiGet(`${getApiUrl()}${getMarketsMarketIdRegionsPath(marketId)}`, headers, queryParams) as Promise<GetMarketsMarketIdRegionsFetchResponse>;
}

export type PostMarketsMarketIdRegionsFetchResponse = 
| FetchResponse<MarketRegionResponseDto, 200> 
| ErrorResponse;

export const postMarketsMarketIdRegionsPath = (marketId: number) => `/markets/${marketId}/regions`;

export const postMarketsMarketIdRegions = (requestContract: MarketRegionsCreateDto, marketId: number, headers = new Headers()):
  Promise<PostMarketsMarketIdRegionsFetchResponse> => {
    const requestData = getApiRequestData<MarketRegionsCreateDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postMarketsMarketIdRegionsPath(marketId)}`, requestData, headers) as Promise<PostMarketsMarketIdRegionsFetchResponse>;
}

export type PostMarketsMarketIdRegionsBulkFetchResponse = 
| FetchResponse<MarketRegionResponseDto[], 200> 
| ErrorResponse;

export const postMarketsMarketIdRegionsBulkPath = (marketId: number) => `/markets/${marketId}/regions/bulk`;

export const postMarketsMarketIdRegionsBulk = (requestContract: MarketRegionsCreateDto[], marketId: number, headers = new Headers()):
  Promise<PostMarketsMarketIdRegionsBulkFetchResponse> => {
    const requestData = getApiRequestData<MarketRegionsCreateDto[]>(requestContract, false);

    return apiPost(`${getApiUrl()}${postMarketsMarketIdRegionsBulkPath(marketId)}`, requestData, headers) as Promise<PostMarketsMarketIdRegionsBulkFetchResponse>;
}

export type DeleteMarketsMarketIdRegionsIdFetchResponse = 
| FetchResponse<void, 204> 
| ErrorResponse;

export const deleteMarketsMarketIdRegionsIdPath = (marketId: number, id: number) => `/markets/${marketId}/regions/${id}`;

export const deleteMarketsMarketIdRegionsId = (marketId: number, id: number, headers = new Headers()):
  Promise<DeleteMarketsMarketIdRegionsIdFetchResponse> => {
    return apiDelete(`${getApiUrl()}${deleteMarketsMarketIdRegionsIdPath(marketId, id)}`, headers, {}) as Promise<DeleteMarketsMarketIdRegionsIdFetchResponse>;
}

export type PatchMarketsMarketIdRegionsIdFetchResponse = 
| FetchResponse<MarketRegionResponseDto, 200> 
| ErrorResponse;

export const patchMarketsMarketIdRegionsIdPath = (marketId: number, id: number) => `/markets/${marketId}/regions/${id}`;

export const patchMarketsMarketIdRegionsId = (requestContract: MarketRegionsUpdateDto, marketId: number, id: number, headers = new Headers()):
  Promise<PatchMarketsMarketIdRegionsIdFetchResponse> => {
    const requestData = getApiRequestData<MarketRegionsUpdateDto>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchMarketsMarketIdRegionsIdPath(marketId, id)}`, requestData, headers) as Promise<PatchMarketsMarketIdRegionsIdFetchResponse>;
}

export type GetRegionsLookupCountryRegionCodeFetchResponse = 
| FetchResponse<MarketRegionResponseDto, 200> 
| FetchResponse<void, 404> 
| ErrorResponse;

export const getRegionsLookupCountryRegionCodePath = (country: string, regionCode: string) => `/regions/lookup/${country}/${regionCode}`;

export const getRegionsLookupCountryRegionCode = (country: string, regionCode: string, headers = new Headers()):
  Promise<GetRegionsLookupCountryRegionCodeFetchResponse> => {
    return apiGet(`${getApiUrl()}${getRegionsLookupCountryRegionCodePath(country, regionCode)}`, headers, {}) as Promise<GetRegionsLookupCountryRegionCodeFetchResponse>;
}

export type GetMarketsMarketIdVerticalsVerticalIdSettingsGeneralFetchResponse = 
| FetchResponse<VerticalGeneralSetupResponseDto, 200> 
| ErrorResponse;

export const getMarketsMarketIdVerticalsVerticalIdSettingsGeneralPath = (marketId: number, verticalId: number) => `/markets/${marketId}/verticals/${verticalId}/settings/general`;

export const getMarketsMarketIdVerticalsVerticalIdSettingsGeneral = (marketId: number, verticalId: number, headers = new Headers()):
  Promise<GetMarketsMarketIdVerticalsVerticalIdSettingsGeneralFetchResponse> => {
    return apiGet(`${getApiUrl()}${getMarketsMarketIdVerticalsVerticalIdSettingsGeneralPath(marketId, verticalId)}`, headers, {}) as Promise<GetMarketsMarketIdVerticalsVerticalIdSettingsGeneralFetchResponse>;
}

export type PatchMarketsMarketIdVerticalsVerticalIdSettingsGeneralFetchResponse = 
| FetchResponse<VerticalGeneralSetupResponseDto, 200> 
| ErrorResponse;

export const patchMarketsMarketIdVerticalsVerticalIdSettingsGeneralPath = (marketId: number, verticalId: number) => `/markets/${marketId}/verticals/${verticalId}/settings/general`;

export const patchMarketsMarketIdVerticalsVerticalIdSettingsGeneral = (requestContract: VerticalGeneralSetupUpdateDto, marketId: number, verticalId: number, headers = new Headers()):
  Promise<PatchMarketsMarketIdVerticalsVerticalIdSettingsGeneralFetchResponse> => {
    const requestData = getApiRequestData<VerticalGeneralSetupUpdateDto>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchMarketsMarketIdVerticalsVerticalIdSettingsGeneralPath(marketId, verticalId)}`, requestData, headers) as Promise<PatchMarketsMarketIdVerticalsVerticalIdSettingsGeneralFetchResponse>;
}

export type GetPartnersPartnerIdScoreFetchResponse = 
| FetchResponse<PartnerScoreResponseDto, 200> 
| ErrorResponse;

export const getPartnersPartnerIdScorePath = (partnerId: number) => `/partners/${partnerId}/score`;

export const getPartnersPartnerIdScore = (partnerId: number, headers = new Headers()):
  Promise<GetPartnersPartnerIdScoreFetchResponse> => {
    return apiGet(`${getApiUrl()}${getPartnersPartnerIdScorePath(partnerId)}`, headers, {}) as Promise<GetPartnersPartnerIdScoreFetchResponse>;
}

export type GetPartnersPartnerIdAddressesFetchResponse = 
| FetchResponse<PartnerAddressResponseDto[], 200> 
| ErrorResponse;

export const getPartnersPartnerIdAddressesPath = (partnerId: number) => `/partners/${partnerId}/addresses`;

export const getPartnersPartnerIdAddresses = (partnerId: number, headers = new Headers()):
  Promise<GetPartnersPartnerIdAddressesFetchResponse> => {
    return apiGet(`${getApiUrl()}${getPartnersPartnerIdAddressesPath(partnerId)}`, headers, {}) as Promise<GetPartnersPartnerIdAddressesFetchResponse>;
}

export type PatchPartnersPartnerIdAddressesIdFetchResponse = 
| FetchResponse<PartnerAddressResponseDto, 200> 
| ErrorResponse;

export const patchPartnersPartnerIdAddressesIdPath = (partnerId: number, id: number) => `/partners/${partnerId}/addresses/${id}`;

export const patchPartnersPartnerIdAddressesId = (requestContract: PartnerAddressUpdateDto, partnerId: number, id: number, headers = new Headers()):
  Promise<PatchPartnersPartnerIdAddressesIdFetchResponse> => {
    const requestData = getApiRequestData<PartnerAddressUpdateDto>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchPartnersPartnerIdAddressesIdPath(partnerId, id)}`, requestData, headers) as Promise<PatchPartnersPartnerIdAddressesIdFetchResponse>;
}

export type GetPartnersPartnerIdBillingProfilesFetchResponse = 
| FetchResponse<PartnerBillingProfileResponseDto[], 200> 
| ErrorResponse;

export const getPartnersPartnerIdBillingProfilesPath = (partnerId: number) => `/partners/${partnerId}/billing-profiles`;

export const getPartnersPartnerIdBillingProfiles = (partnerId: number, headers = new Headers()):
  Promise<GetPartnersPartnerIdBillingProfilesFetchResponse> => {
    return apiGet(`${getApiUrl()}${getPartnersPartnerIdBillingProfilesPath(partnerId)}`, headers, {}) as Promise<GetPartnersPartnerIdBillingProfilesFetchResponse>;
}

export type PatchPartnersPartnerIdBillingProfilesIdFetchResponse = 
| FetchResponse<PartnerBillingProfileUpdateDto, 200> 
| ErrorResponse;

export const patchPartnersPartnerIdBillingProfilesIdPath = (partnerId: number, id: number) => `/partners/${partnerId}/billing-profiles/${id}`;

export const patchPartnersPartnerIdBillingProfilesId = (requestContract: PartnerBillingProfileUpdateDto, partnerId: number, id: number, headers = new Headers()):
  Promise<PatchPartnersPartnerIdBillingProfilesIdFetchResponse> => {
    const requestData = getApiRequestData<PartnerBillingProfileUpdateDto>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchPartnersPartnerIdBillingProfilesIdPath(partnerId, id)}`, requestData, headers) as Promise<PatchPartnersPartnerIdBillingProfilesIdFetchResponse>;
}

export type GetPartnersPartnerIdBankAccountsFetchResponse = 
| FetchResponse<PartnerBankAccountResponseDto[], 200> 
| ErrorResponse;

export const getPartnersPartnerIdBankAccountsPath = (partnerId: number) => `/partners/${partnerId}/bank-accounts`;

export const getPartnersPartnerIdBankAccounts = (partnerId: number, headers = new Headers()):
  Promise<GetPartnersPartnerIdBankAccountsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getPartnersPartnerIdBankAccountsPath(partnerId)}`, headers, {}) as Promise<GetPartnersPartnerIdBankAccountsFetchResponse>;
}

export type PatchPartnersPartnerIdBankAccountsIdFetchResponse = 
| FetchResponse<PartnerBankAccountUpdateDto, 200> 
| ErrorResponse;

export const patchPartnersPartnerIdBankAccountsIdPath = (partnerId: number, id: number) => `/partners/${partnerId}/bank-accounts/${id}`;

export const patchPartnersPartnerIdBankAccountsId = (requestContract: PartnerBankAccountUpdateDto, partnerId: number, id: number, headers = new Headers()):
  Promise<PatchPartnersPartnerIdBankAccountsIdFetchResponse> => {
    const requestData = getApiRequestData<PartnerBankAccountUpdateDto>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchPartnersPartnerIdBankAccountsIdPath(partnerId, id)}`, requestData, headers) as Promise<PatchPartnersPartnerIdBankAccountsIdFetchResponse>;
}

export type GetPartnersStatisticsKeyStatisticsFetchResponse = 
| FetchResponse<PartnerKeyStatisticResponseDto[], 200> 
| ErrorResponse;

export const getPartnersStatisticsKeyStatisticsPath = () => `/partners/statistics/key-statistics`;

export const getPartnersStatisticsKeyStatistics = (regionId?: number | undefined | null, marketId?: number | undefined | null, headers = new Headers()):
  Promise<GetPartnersStatisticsKeyStatisticsFetchResponse> => {
    const queryParams = {
      "regionId": regionId,
      "marketId": marketId
    }
    return apiGet(`${getApiUrl()}${getPartnersStatisticsKeyStatisticsPath()}`, headers, queryParams) as Promise<GetPartnersStatisticsKeyStatisticsFetchResponse>;
}

export type GetPartnersPartnerIdBalanceTransactionsFetchResponse = 
| FetchResponse<PartnerBalanceTransactionResponseDto[], 200> 
| ErrorResponse;

export const getPartnersPartnerIdBalanceTransactionsPath = (partnerId: number) => `/partners/${partnerId}/balance-transactions`;

export const getPartnersPartnerIdBalanceTransactions = (partnerId: number, headers = new Headers()):
  Promise<GetPartnersPartnerIdBalanceTransactionsFetchResponse> => {
    return apiGet(`${getApiUrl()}${getPartnersPartnerIdBalanceTransactionsPath(partnerId)}`, headers, {}) as Promise<GetPartnersPartnerIdBalanceTransactionsFetchResponse>;
}

export type PostPartnersPartnerIdBalanceTransactionsFetchResponse = 
| FetchResponse<PartnerBalanceTransactionResponseDto, 200> 
| ErrorResponse;

export const postPartnersPartnerIdBalanceTransactionsPath = (partnerId: number) => `/partners/${partnerId}/balance-transactions`;

export const postPartnersPartnerIdBalanceTransactions = (requestContract: PartnerBalanceTransactionManualCreateDto, partnerId: number, headers = new Headers()):
  Promise<PostPartnersPartnerIdBalanceTransactionsFetchResponse> => {
    const requestData = getApiRequestData<PartnerBalanceTransactionManualCreateDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postPartnersPartnerIdBalanceTransactionsPath(partnerId)}`, requestData, headers) as Promise<PostPartnersPartnerIdBalanceTransactionsFetchResponse>;
}

export type GetUserRolesFetchResponse = 
| FetchResponse<UserRoleResponseDto[], 200> 
| ErrorResponse;

export const getUserRolesPath = () => `/user-roles`;

export const getUserRoles = (headers = new Headers()):
  Promise<GetUserRolesFetchResponse> => {
    return apiGet(`${getApiUrl()}${getUserRolesPath()}`, headers, {}) as Promise<GetUserRolesFetchResponse>;
}

export type PostUserRolesFetchResponse = 
| FetchResponse<UserRoleResponseDto, 200> 
| ErrorResponse;

export const postUserRolesPath = () => `/user-roles`;

export const postUserRoles = (requestContract: UserRoleCreateDto, headers = new Headers()):
  Promise<PostUserRolesFetchResponse> => {
    const requestData = getApiRequestData<UserRoleCreateDto>(requestContract, false);

    return apiPost(`${getApiUrl()}${postUserRolesPath()}`, requestData, headers) as Promise<PostUserRolesFetchResponse>;
}

export type GetUserRolesRoleFetchResponse = 
| FetchResponse<UserRoleResponseDto, 200> 
| ErrorResponse;

export const getUserRolesRolePath = (role: string) => `/user-roles/${role}`;

export const getUserRolesRole = (role: string, headers = new Headers()):
  Promise<GetUserRolesRoleFetchResponse> => {
    return apiGet(`${getApiUrl()}${getUserRolesRolePath(role)}`, headers, {}) as Promise<GetUserRolesRoleFetchResponse>;
}

export type PatchUserRolesNameFetchResponse = 
| FetchResponse<UserRoleResponseDto, 200> 
| ErrorResponse;

export const patchUserRolesNamePath = (name: string) => `/user-roles/${name}`;

export const patchUserRolesName = (requestContract: UserRoleUpdateDto, name: string, headers = new Headers()):
  Promise<PatchUserRolesNameFetchResponse> => {
    const requestData = getApiRequestData<UserRoleUpdateDto>(requestContract, false);

    return apiPatch(`${getApiUrl()}${patchUserRolesNamePath(name)}`, requestData, headers) as Promise<PatchUserRolesNameFetchResponse>;
}

export type GetUserRolesRoleUsersFetchResponse = 
| FetchResponse<UserListResponseDto[], 200> 
| ErrorResponse;

export const getUserRolesRoleUsersPath = (role: string) => `/user-roles/${role}/users`;

export const getUserRolesRoleUsers = (role: string, headers = new Headers()):
  Promise<GetUserRolesRoleUsersFetchResponse> => {
    return apiGet(`${getApiUrl()}${getUserRolesRoleUsersPath(role)}`, headers, {}) as Promise<GetUserRolesRoleUsersFetchResponse>;
}
